export default {
  v5: {
    my_video_shorts: '내 동영상 쇼츠',
    see_more: '더보기',
    no_shorts_found: '쇼츠를 찾을 수 없음',
    shorts: '쇼츠',
    general_information: '일반 정보',
    gamification: '게이미피케이션',
    click_to_select_files: '파일 선택하려면 클릭',
    selected_files: '선택된 파일',
    uploaded: '업로드됨',
    failed: '실패',
    system_will_automatically_analyze_and_select_the_most_relevant:
      '시스템이 자동으로 분석하여 콘텐츠 요구사항에 따라 조직의 라이브러리에서 가장 관련성이 높은 문서를 선택합니다.',
    select_from_library: ' 라이브러리에서 선택',
    search_document: '문서 검색...',
    selected: '선택됨',
    loading_documents: '문서 불러오는 중...',
    review_generated_content: '생성된 콘텐츠 검토',
    confirm_and_replace_content: '콘텐츠 확인 후 교체',
    the_generate_content_will_replace:
      '생성된 콘텐츠가 선택된 페이지의 기존 텍스트를 대체합니다. 변경을 적용하고 싶지 않으면 이전 단계로 돌아가세요.',
    pages_to_be_updated: '업데이트될 페이지',
    generated_revisions: '생성된 수정 사항',
    lesson_preview: '레슨 미리보기',
    create_new_folder: '새 폴더 만들기',
    rename_item: '항목 이름 변경',
    enter_folder_name: '폴더 이름 입력:',
    enter_new_name: '새 이름 입력:',
    folder_name: '폴더 이름:',
    new_name: '새 이름',
    move_items: '항목 이동',
    copy_items: '항목 복사',
    move_here: '여기로 이동',
    copy_here: '여기로 복사',
    select_destination_library_and_folder: '대상 라이브러리 및 폴더 선택:',
    items_selected: '선택된 항목',
    version: '버전',
    modified_by: '수정자',
    size: '크기',
    restore: '복원',
    are_you_sure_you_want_to_restore_this_version:
      '이 버전을 복원하시겠습니까?',
    this_will_replce_the_current_version_with_the_selected_one:
      '현재 버전이 선택한 버전으로 교체됩니다.',
    restore_this_version: '이 버전 복원',
    restore_not_available: '복원 불가',
    version_history: '버전 기록:',
    by_making_items_public:
      '항목을 공개하면 모든 사람이 볼 수 있습니다. 계속하기 전에 이용 약관을 확인하세요.',
    the_selected_items_will_be_copied:
      '선택한 항목이 공개 라이브러리에 복사되어 모든 사람이 볼 수 있습니다.',
    the_selected_items_will_be_copied_to_org:
      '선택한 항목이 조직 라이브러리에 복사되어 모든 조직 구성원이 볼 수 있습니다.',
    the_selected_items_will_be_copied_to_your_private:
      '선택한 항목이 개인 라이브러리에 복사되어 본인만 볼 수 있습니다.',
    loading_organization: '조직 사용자 불러오는 중...',
    click_download_to_view: '보기 위해 다운로드 클릭',
    archive_file: '아카이브 파일',
    no_preview_available: '미리보기 불가',
    audit_report: '감사 보고서',
    audit_type: '작업 유형',
    i_agree_to_the_terms_and_conditions: '이용 약관에 동의합니다.',
    this_file_is_indexed_for_ai: '이 파일은 AI용으로 색인됨',
    file_is_not_indexed_for_ai: '이 파일은 AI용으로 색인되지 않음',
    no_users_found: '사용자를 찾을 수 없음',
    no_users_available: '사용 가능 사용자 없음',
    add_people: '사용자 추가',
    people: '사용자',
    access_type: '액세스 유형',
    no_group_found: '그룹을 찾을 수 없음',
    add_group: '그룹 추가',
    groups: '그룹',
    users_top: '사용자',
    confirm_delete: '삭제 확인',
    do_you_want_remove: '정말 제거하시겠습니까?',
    form_this_documents_permissions: '이 문서의 권한에서?',
    no_users_found_in_this_group: '이 그룹에서 사용자를 찾을 수 없음',
    add_selected_users: '선택한 사용자 추가',
    choose_users_from_the_list: '목록에서 사용자 선택',
    selected_users: '선택한 사용자',
    archived: '보관됨',
    request_approval: '승인 요청',
    document_in_review: '문서 검토 중',
    approve: '승인',
    reject: '거부',
    comment: '댓글:',
    enter_your_commit: '댓글 입력...',
    confirm_cancel: '취소 확인',
    upload_3d_zip: '3D ZIP 업로드',
    delete_items: '항목 삭제',
    video_upload_request: '비디오 업로드 요청',
    reject_video: '비디오 거부',
    enter_rejection_reason: '거부 사유 입력...',
    please_provide_a_reason_for_reejection_this_video:
      '이 비디오를 거부하는 이유를 입력하세요:',
    generate_trivia_with_ai: 'AI로 퀴즈 생성',
    select_category: '카테고리 선택:',
    number_of_question: '질문 수',
    generated_questions: '생성된 질문',
    this_will_clear_all_generate_question:
      '모든 생성된 질문이 삭제됩니다. 계속하시겠습니까?',
    sure_delete: '정말 삭제하시겠습니까?',
    delete_this_question: '정말 이 질문을 삭제하시겠습니까?',
    loading_quiz: '퀴즈 불러오는 중...',
    creteing_file: '파일 생성 중',
    opening_desktop_app: '데스크탑 앱 열기...',
    this_folder_is_empty: '이 폴더는 비어 있습니다',
    select_a_competition: '경쟁 선택...',
    activity_badges: '활동 배지',
    awarded_every_badges: '4, 8, 16, 32, 64, 128, 256, 512 로그인마다 수여',
    learning_badges: '학습 배지',
    awarded_every_courses: '1, 4, 8, 16, 32, 64, 128 완료된 과정마다 수여',
    test_badges: '시험 배지',
    awarded_every_passes_tests:
      '2, 4, 8, 16, 32, 64, 128, 256 합격한 시험마다 수여',
    assignment_badges: '과제 배지',
    awarded_every_passed_assignments:
      '1, 2, 4, 8, 16, 32, 64, 128 완료된 과제마다 수여',
    perfectionism_badges: '완벽주의 배지',
    awarded_every_assignments_with_scrore:
      '점수 90% 이상인 테스트 또는 과제마다 수여',
    communication_badges: '커뮤니케이션 배지',
    awarded_every_topics_or_comments:
      '2, 4, 8, 16, 32, 64, 128, 256 토픽 또는 댓글마다 수여',
    certification_badges: '인증 배지',
    awarded_every_certificates: '1, 2, 4, 8, 16, 32, 64, 128 인증서마다 수여',
    level_name: '레벨 이름',
    delete_competition: '경쟁 삭제',
    this_week: '이번 주',
    this_year: '올해',
    make_organization: '조직으로 만들기',
    no_results_found: '결과를 찾을 수 없음',
    no_items_available: '사용 가능한 항목 없음',
    help_video: '도움말 비디오',
    select_a_video_from_the_list: '학습을 시작하려면 목록에서 비디오 선택'
  },
  v4: {
    drop_files: '파일을 드래그하여 업로드할 위치를 선택하세요.',
    duplicate_lessoon: '해당 강의는 이미 코스에 포함되어 있습니다.',
    skill_rule_title: '스킬 여정 제목을 입력해주세요',
    imageCreatorTitle: '이미지 생성기',
    isTranslated: '번역 완료됨',
    translationCourseDesc:
      '이 코스의 번역에는 몇 분 정도 소요될 수 있습니다. 기다려 주셔서 감사합니다!',
    translateCourseTip:
      '원본과 독립적으로 수정 가능한 번역 코스를 생성하세요. 모든 강의 및 페이지가 포함됩니다.',
    translateModalBtn: '번역하기',
    translationSuccess: '코스 "<0/>"가 성공적으로 번역되었습니다!',
    translatingCourse: '코스 번역 중...',
    translateModalTitle: '코스 번역하기',
    translateSelectLang: '언어 선택',
    fileDeleteconfirm:
      '이 파일을 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.',
    fileDeleteMessage: '파일이 성공적으로 삭제되었습니다.',
    fileDeleteFailedMessage: '파일 삭제에 실패했습니다!',
    fileDelete: '이 파일 삭제',
    certificate_save_btn: '다음에 증명서를 추가:',
    maze_path_info: '그래프에 사용할 수 있는 경로가 없습니다!',
    file_size_mb: '파일 크기는 25MB 이하여야 합니다!',
    reports: {
      products: '제품',
      users: '사용자',
      ph_username: '사용자 이름으로 검색',
      ph_id: '사용자 ID 번호로 검색',
      ph_email: '사용자 이메일로 검색'
    },
    select_upload_section_id: '섹션 파일이 필요합니다',
    tags_all: '전체',
    delete_file_confirm: '이 파일을 삭제하시겠습니까?',
    delete_file_title: '파일 삭제',
    tooltip_publish: '선택한 옵션으로 코스를 게시합니다',
    tooltip_save: '현재 업데이트로 코스를 저장합니다',
    tooltip_next: '다음 코스 설정으로 이동',
    tooltip_finish: '현재 업데이트를 완료하고 저장합니다',
    stories_modal: {
      title_upload: '스토리 업로드',
      title_update: '스토리 업데이트',
      title_audio: '오디오 스토리 파일',
      btn_upload: '업로드',
      btn_update: '업데이트',
      btn_close: '닫기',
      btn_cancel: '취소',
      lbl_cover: '스토리 커버 이미지',
      rule_cover: '스토리 오디오 커버를 업로드해주세요!',
      lbl_title: '스토리 오디오 제목',
      rule_title: '스토리 오디오 제목을 입력해주세요!',
      lbl_description: '스토리 오디오 설명',
      rule_description: '스토리 오디오 설명을 입력해주세요!',
      lbl_file: '스토리 오디오 파일 업로드',
      rule_file: '스토리 오디오 파일을 업로드해주세요!',
      rule_file_type: '유효한 스토리 오디오 파일을 업로드해주세요!',
      lbl_select_file: '스토리 오디오 파일 선택',
      msg_valid_file: '유효한 스토리 오디오 파일을 선택해주세요!',
      msg_success: '스토리 오디오 파일이 성공적으로 업로드되었습니다',
      msg_failed: '미디어 데이터 할당에 실패했습니다!',
      msg_error: '파일 업로드 중 오류가 발생했습니다!'
    },
    audio_modal: {
      title_upload: '업로드',
      title_update: '업데이트',
      title_audio: '오디오 파일',
      btn_upload: '업로드',
      btn_update: '업데이트',
      btn_close: '닫기',
      btn_cancel: '취소',
      lbl_cover: '오디오 커버',
      rule_cover: '오디오 커버를 업로드해주세요!',
      lbl_title: '오디오 제목',
      rule_title: '오디오 제목을 입력해주세요!',
      lbl_description: '오디오 설명',
      rule_description: '오디오 설명을 입력해주세요!',
      lbl_file: '오디오 파일 업로드',
      rule_file: '오디오 파일을 업로드해주세요!',
      rule_file_type: '유효한 오디오 파일을 업로드해주세요!',
      lbl_select_file: '오디오 파일 선택',
      msg_valid_file: '유효한 오디오 파일을 선택해주세요!',
      msg_success: '오디오 파일이 성공적으로 업로드되었습니다',
      msg_failed: '미디어 데이터 할당에 실패했습니다!',
      msg_error: '파일 업로드 중 오류가 발생했습니다!'
    },
    info_episode: '에피소드의 커버 이미지입니다.',
    btn_delete_episode: '이 팟캐스트 에피소드를 삭제합니다.',
    btn_edit_marketplace: '마켓플레이스 정보 수정',
    btn_save_marketplace: '현재 변경사항 저장',
    btn_ai_podcast: 'AI 기반 팟캐스트 에피소드 생성',
    btn_upload_podcast: '직접 녹음한 팟캐스트 오디오 업로드',
    attach_file: '청중과 더 많은 콘텐츠를 공유하려면 파일을 업로드하세요',
    fileDownload: '이 파일 다운로드',
    singleEpishode: '에피소드',
    podcast_music: '팟캐스트, 음악 및 스토리',
    publishHeader: '팟캐스트, 음악 및 스토리 게시',
    editHeader: '팟캐스트, 음악 및 스토리 편집',
    createHeader: '팟캐스트, 음악 및 스토리 생성',
    marketplaceHeader: '팟캐스트, 음악 및 스토리 마켓플레이스 상세 정보',
    message_marketplace: '마켓플레이스 양식을 모두 작성해주세요!',
    create_podcast_live: '라이브 팟캐스트 및 음악',
    create_podcast_custom: '맞춤형 팟캐스트 및 음악',
    create_podcast_stories: '스토리',
    ai_Assisted_podcast_reation: 'AI 지원 팟캐스트 및 음악',
    publishTitle:
      '공개적으로 볼 수 있도록 팟캐스트, 음악 및 스토리를 게시합니다.',
    customButton: '맞춤형 생성',
    customTitle: '팟캐스트에 적용된 변경사항 저장',
    updateButton: '업데이트',
    createButton: '생성',
    createNewButton: '새로 생성',
    updateTitle: '현재 팟캐스트, 음악 및 스토리 정보를 업데이트합니다.',
    createTitle: '새 팟캐스트, 음악 및 스토리 생성',
    createNewTitle:
      '현재 입력된 정보를 기반으로 새 팟캐스트, 음악 및 스토리를 생성합니다.',
    podcastTitle: '에피소드 목록',
    podcastStoryTitle: '스토리 에피소드 목록',
    podcastToolTipTitle: '팟캐스트 에피소드 목록',
    uploadAudio: '오디오 업로드',
    aiAudio: 'AI 오디오',
    emptyPodcast: '아직 녹음된 팟캐스트, 음악 또는 스토리가 없습니다.',
    emptyStoriesPodcast: '추가된 스토리가 없습니다.',
    emptyCreatePodcast: '오디오를 추가하려면 먼저 팟캐스트를 생성해주세요.',
    playPodcast: '선택한 팟캐스트, 음악 및 스토리를 재생합니다.',
    pausePodcast: '선택한 팟캐스트, 음악 및 스토리를 일시정지합니다.',
    selectPodcast: '이 팟캐스트, 음악 및 스토리를 선택합니다.',
    downloadPodcast: '이 오디오 다운로드',
    uploadAudioFile: '새 오디오를 업로드하여 기존 오디오를 교체합니다.',
    deleteConfirm: '이 오디오를 삭제하시겠습니까?',
    roomName: '팟캐스트 이름',
    addGuestTitle: '게스트 스피커 추가',
    showTime: '방송 시간',
    startTime: '시작 시간',
    endTime: '종료 시간',
    erorMsgImg: '유효한 이미지를 선택해주세요.',
    failedMsgImg: '이미지를 불러오는 데 실패했습니다. 다시 시도해주세요!',
    failedMsgUpload: '커버 이미지 업로드에 실패했습니다!',
    btnCoverUpload: '커버 업로드',
    is_private: '비공개',
    to_attach: '파일 첨부',
    file_attached: '첨부된 파일',
    main_event: '주요 이벤트',
    event: '이벤트',
    upload_pdf: 'PDF 업로드',
    portrait: '세로',
    landscape: '가로',
    import_from_library: '미디어 라이브러리에서 텍스트 가져오기',
    question_answer_ai: '질문/답변 AI',
    take_maze: '메타미로 참여',
    training: '훈련',
    select_transcribe_locale: '필기 언어 선택',
    transcribe_limit: '필기할 분수를 입력하세요',
    not_complete: '마켓플레이스 정보가 완성되지 않았습니다',
    complete: '마켓플레이스 정보가 완성되었습니다',
    not_admin: '마켓플레이스에 게시하려면 관리자 권한이 필요합니다',
    no_course:
      '제목을 입력하고 이미지를 선택해야 마켓플레이스를 활성화할 수 있습니다',
    scorm_not_complete:
      'SCORM 파일을 업로드하려면 제목을 입력하고 이미지를 선택하세요',
    not_found_maze: '메타미로를 찾을 수 없습니다',
    email_require: '이메일이 필요합니다',
    poll_required: '설문조사 데이터가 필요합니다',
    alert: '알림!',
    warning: '경고!',
    ok: '확인',
    cancel: '취소',
    done: '완료',
    insert: '삽입',
    private: '비공개',
    public: '공개',
    no_connection: '인터넷 연결이 끊겼습니다',
    switch: '전환',
    share_screen: '화면 공유',
    stop_share_screen: '화면 공유 중지',
    share_screen_with_camera: '카메라와 함께 화면 공유',
    stop_share_screen_with_camera: '카메라와 함께한 화면 공유 중지',
    camera_on: '카메라 켜기',
    camera_off: '카메라 끄기',
    mic_on: '음소거 해제',
    mic_off: '음소거',
    fullscreen: '전체 화면',
    live_now: '실시간 방송 중',
    schedule_on: '예약 시간:',
    organisations: '조직',
    org_groups: '조직 그룹',
    specific_user: '특정 사용자',
    gif: 'GIF',
    unavailable: '사용 불가',
    yes: '예',
    no: '아니오',
    event_duration_message: '최대 300분 (5시간)',
    send_email: '이메일 알림 보내기',
    admin_only: '관리자 전용',
    join: '참여',
    leave: '나가기',
    share: '공유',
    share_text: '파일을 공유할 이메일 주소를 입력하세요.',
    share_text_title: 'PDF 공유',
    share_text_title_txt: '텍스트 공유',
    select_users: '사용자 선택',
    delete: '삭제',
    attachment_event: '이벤트 첨부 파일:',
    transcribe_limit: '필기 시간',
    monthly_transcribe: '월간 필기 제한:',
    enable_ai: 'AI 활성화:',
    enable_maze: '메타미로 활성화:',
    media_service: '미디어 서비스',
    allow_others: '다른 사용자의 편집 허용',
    join_breakout_room: '분과 세션 참여',
    bio: '소개',
    linkedin: 'LinkedIn',
    select_org_report: '보고서를 생성할 조직을 찾고 선택하세요.',
    org_image_not_found: '이미지를 찾을 수 없습니다',
    insert_text: '텍스트 삽입',
    insert_question_answer: '질문/답변 AI',
    modal_title2: '텍스트 갤러리',
    my_text_library: '내 텍스트 라이브러리',
    ai: 'AI',
    public_text_library: '공개 텍스트 라이브러리',
    organization_text_library: '조직 텍스트 라이브러리',
    no_transcribed_text: '필기된 텍스트가 없습니다',
    public_text_not_found: '공개 필기 텍스트를 찾을 수 없습니다',
    org_text_not_found: '조직 필기 텍스트를 찾을 수 없습니다',
    org_video_not_found: '비디오를 찾을 수 없습니다',
    canva: 'Canva에서 만들기',
    canva_open: '여기를 클릭하여 Canva 편집기를 엽니다.',
    pdf: 'PDF',
    txt: '텍스트',
    human: '프리미엄',
    shared_file: '파일이 성공적으로 공유되었습니다.',
    error_shared_file: '파일 공유에 문제가 발생했습니다. 다시 시도하세요.',
    publish: '게시',
    maze_scenes: '메타미로 장면',
    pexel_images: 'Pexel 이미지',
    group: '그룹',
    group_name: '그룹 이름',
    select_group: '그룹 선택',
    search_maze: '메타미로 검색',
    hosts: '호스트',
    avg_score: '평균 점수 (%)',
    maze_report: '미로 보고서',
    maze_view: '미로 보기',
    title_maze: '메타미로',
    author: '작성자',
    match: '경로 일치',
    preview_mazeTitle: '제목: ',
    other: '기타',
    total: '총계',
    report_course: '코스',
    report_courses: '코스들',
    report_event: '이벤트',
    report_events: '이벤트들',
    report_maze: '미로',
    report_personalize_learning: '맞춤형 학습',
    report_live_assessment: '실시간 평가',
    report_live_assessments: '실시간 평가들',
    report_skill_journey: '기술 여정',
    skill_journey: '기술 여정',
    skill_journeys: '기술 여정들',
    date: '날짜: ',
    search_people: '사람 검색',
    passed: '통과',
    failed: '실패',
    item: '항목',
    type: '유형',
    minimum_pass_score: '최소 통과 점수',
    resources_count: '리소스 수',
    back: '뒤로',
    resources: '리소스',
    time_spent: '소요 시간 (분)',
    detail: '세부 정보',
    watched_time_mins: '시청 시간 (분)',
    personalize_learning: '맞춤형 학습',
    result: '결과',
    assessment_title: '제목',
    marketPlace_graph: '마켓플레이스 그래프',
    attachments: '추가 첨부 파일',
    new_scorm_course: '새 SCORM 과정 업로드',
    upload_scorm_course: 'SCORM 과정 업로드',
    new_maze: '새 메타메이즈 만들기',
    new_skill_journey: '스킬 여정 만들기',
    tags_scorm: 'SCORM',
    tags_skillJourney: '스킬 여정',
    new_discussion_room: '새 팟캐스트 만들기',
    title: '오늘 무엇을 하시겠습니까?',
    build_course: '내 과정 만들기',
    live_broadcast: '라이브 방송',
    invite_users: '내 조직에 사용자 초대하기',
    build_voice_over: '내 보이스오버 만들기',
    view_reports: '보고서 보기',
    upload_media: '내 미디어나 작업 업로드 및 공유하기',
    main_menu: '메인 메뉴',
    get_started: '시작하기',
    search_group: '조직 그룹 검색',
    ai_course: 'AI 과정',
    search_user: '회사 이름 검색',
    no_maze: '현재 메타메이즈가 없습니다.',
    conference_event_title: '컨퍼런스 이벤트',
    conference_event_subTitle: '종료된 컨퍼런스 이벤트',
    conference_event: '현재 컨퍼런스 이벤트가 없습니다.',
    no_skill: '현재 스킬 여정이 없습니다.',
    no_podcast: '현재 팟캐스트가 없습니다.',
    maze_channel: '메타메이즈',
    past_live_assessment: '지난 라이브 평가',
    no_live_assessment: '현재 라이브 평가가 없습니다.',
    enrolled_courses: '과정',
    my_video_channel: '내 비디오 채널',
    enrolled_liveEvents: '라이브 이벤트',
    sharebot: '쉐어봇',
    selected_language: '선택된 언어',
    shareSphere_game: '쉐어스피어 게임',
    maze: '메타메이즈',
    skill: '스킬 여정',
    channel: '채널',
    order: '주문',
    is_record: '녹화',
    no_maze_found: '메타메이즈를 찾을 수 없습니다.',
    maze_self_limit_reached: '메타메이즈 자기 평가 한도에 도달했습니다.',
    metamaze_two_times: '이 메타메이즈를 이미 두 번 수행하셨습니다.',
    metamaze_two_times_no_result:
      '이 메타메이즈를 이미 두 번 수행하셨습니다. 세 번째부터는 자기 평가 결과가 저장되지 않습니다.',
    scorm_zip: 'SCORM ZIP',
    pass_score: '통과 기준 점수',
    organization: '조직을 선택하세요',
    pass_score_mark: '1에서 100 사이의 점수를 입력하세요',
    maze_cloning_success: '메타메이즈 "<0/>" 복제에 성공했습니다!',
    create_certificate: '인증서 만들기',
    create_badge: '배지 만들기',
    certificate_added: '인증서가 추가되었습니다.',
    badge_added: '배지가 추가되었습니다.',
    certificate_warning: '인증서/배지는 발행 후에는 수정할 수 없습니다!',
    created_course_plan:
      '생성한 과정을 편집하고 라이브 이벤트를 계획 및 발행하세요',
    market_place_space: '마켓플레이스',
    select_course_language: '언어 선택 (선택 사항)',
    select_language: '언어 선택',
    file_upload: '파일 업로드',
    text: '여기에 텍스트를 작성하세요…',
    attempts_count: '사용자가 재시도할 수 있는 횟수',
    no_of_people_placeholder: '인원 수',
    back_to_maze: '메타메이즈 시나리오로 돌아가기',
    edit_maze: '메이즈 편집',
    wait: '잠시만 기다려주세요...',
    retry: '재시도',
    publish_scorm_course: 'SCORM 과정 발행하기',
    publish_maze: '메타메이즈 발행하기',
    import: '요소 가져오기',
    answer_correct: '정답을 선택하세요',
    author_name: `작성자의 이름을 입력하세요`,
    select_category: '카테고리를 선택하세요',
    course_outline: '과정 개요를 입력하세요',
    course_obj: '과정 목표를 입력하세요',
    course_description: '과정 설명을 입력하세요',
    maze_outline: '미로 개요를 입력하세요',
    maze_obj: '미로 목표를 입력하세요',
    maze_description: '미로 설명을 입력하세요',
    lessons: '강의 수를 입력하세요',
    user_email_require: `사용자 이메일이 필요합니다`,
    team_size: `팀 규모를 입력하세요`,
    enter_price: '가격을 입력하세요 (5 이상)',
    input_title_maze: '미로 제목을 입력하세요',
    trainer_bio: '강사 소개를 입력하세요',
    trainer_linkedin: '강사의 LinkedIn 링크를 입력하세요',
    error_video: '비디오 수를 입력하세요',
    input_video_link: '비디오 링크를 입력하세요',
    number_of_video: '비디오 수',
    number_of_lessions: '강의 수',
    no_of_people_in_conference: '회의에 몇 명이 참석합니까?',
    transcribe_settings: '전사 설정',
    transcribe: '전사하기',
    cloning_maze: '메타미로 복제 중...',
    id_number: 'ID 번호',
    timezone: '시간대',
    edit_maze: '편집',
    delete_maze: '삭제',
    view_maze: '보기',
    create_metamaze: '메타미로 생성',
    metamaze_scenario: '메타미로 시나리오',
    publish_metamaze: '게시 설정',
    search_result: '검색 결과:',
    search_for: '검색:',
    search_no_result: '- 검색 결과가 없습니다!',
    channel_no_available: '사용 가능한 채널이 없습니다!',
    this_card: '이것은 카드입니다',
    course_no_available: '사용 가능한 과정이 없습니다!',
    exit_fullscreen: '전체 화면 종료',
    bg_image: '배경 이미지',
    introduction: '소개',
    summary: '요약',
    generate_introduction: '소개 생성',
    generate_summary: '요약 생성',
    bullet_points: '글머리 기호',
    title_simulation: '시뮬레이션 이름을 입력하세요',
    view_generated_images: '생성된 이미지 보기',
    image_transparency: '이미지 투명도',
    template_bg_color: '템플릿 배경 색상',
    select_template_layout: '템플릿 레이아웃 선택',
    reload_template: '(템플릿 다시 불러오기)',
    are_you_sure_want_close: '정말 닫으시겠습니까?',
    all_your_changes_will_be_lost: '모든 변경사항이 저장되지 않습니다.',
    please_checked_before_generated_video:
      '비디오 생성 전에 모든 조건을 확인했는지 확인해주세요.',
    voice_must_be_selected: '음성을 선택해야 합니다',
    avatar_must_be_selected: '아바타 이미지를 선택해야 합니다.',
    maximum_five_slides_try_again:
      '파일에서 이미지를 추출하는 중 오류가 발생했습니다. 슬라이드는 최대 5장이어야 하며 각 슬라이드에는 노트가 있어야 합니다. 다시 시도해주세요!',
    back_to_upload: '업로드로 돌아가기',
    uploading_file_to_server: '파일을 서버로 업로드 중',
    extracting_images_from_your_file: '파일에서 이미지 추출 중',
    upload_your_ppt_or_drag:
      '프레젠테이션 파일(.PPTX)을 업로드하거나 이곳에 드래그하세요.',
    maximum_five_slides_error:
      'PowerPoint 파일은 최대 5개의 슬라이드를 포함하고 각 슬라이드에 노트가 있어야 합니다. 그렇지 않으면 오류가 발생할 수 있습니다.',
    number_of_questions_generated: '생성할 질문 수',
    quiz_page_this_cannot_be_done:
      '이 페이지에 퀴즈를 추가하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
    confirm_selection: '선택 확인',
    select_quiz_page: '퀴즈 페이지 선택',
    lesson_do_you_want_add_this_quiz:
      '강의의 어느 부분에 이 퀴즈를 추가하시겠습니까?',
    beginning_of_lesson: '강의 시작 부분',
    end_of_lesson: '강의 끝 부분',
    currently_active_page: '현재 활성화된 페이지',
    finish: '완료',
    upload_selection_file: '섹션 파일 업로드',
    general_quiz: '일반 퀴즈',
    manage_sequence: '순서 관리',
    save_sequence: '순서 저장',
    new: '새로운',
    in_progress: '진행 중',
    recommended_course: '추천 과정',
    up_coming: '예정됨',
    past_live: '지난 라이브',
    input_your_channel_name: '채널 이름을 입력하세요!',
    organization_place: '기관 마켓플레이스',
    marketplace_report: '마켓플레이스 리포트',
    story_writing: '스토리 작성',
    Ai_quiz: 'AI 퀴즈',
    generate_quiz: '퀴즈 생성',
    create_story: '스토리 생성',
    change_layout_page: '이 페이지의 레이아웃을 변경하려고 합니다.',
    change_layout_message:
      '텍스트, 이미지, 배경, 로고만 유지됩니다. 다른 모든 요소는 페이지에서 제거됩니다.',
    reviews: '리뷰',
    tab_attachments: '첨부파일',
    zoom_in: '확대',
    zoom_out: '축소',
    zoom_reset: '확대/축소 초기화',
    no_attachment: '첨부파일이 없습니다.',
    select_upload_simulation: '시뮬레이션을 선택/업로드하세요.',
    quiz_updated_successfully: '퀴즈가 성공적으로 업데이트되었습니다!',
    quizes: '퀴즈',
    trivia: '퀴즈 게임',
    closing: '닫는 중...',
    products: '제품',
    ask_questions: '질문을 입력하세요...',
    course_information: '과정 정보',
    course_assistance: '과정 생성 도움말',
    go_back: '뒤로 가기',
    ai_generate_content_progress: '콘텐츠 생성 진행 중',
    view_generate_content: '생성된 콘텐츠 보기',
    generate_error: '생성 오류!',
    confirm_creating_course: '이 콘텐츠로 과정을 생성하시겠습니까?',
    generate_content_automatically:
      '생성된 모든 콘텐츠가 자동으로 과정의 레슨과 페이지로 추가됩니다.',
    quiz_created_successfully: '퀴즈가 성공적으로 생성되었습니다!',
    create_quiz: '퀴즈 생성',
    quiz_setting: '퀴즈 설정',
    please_fill_quiz_setting: '* 퀴즈 설정의 모든 항목을 입력해 주세요',
    question_list: '질문 목록',
    add_quiz_to_page: '페이지에 퀴즈 추가',
    form_create_question: '질문 생성 양식',
    user_information_updated: '사용자 정보가 업데이트되었습니다!',
    your_stripe_activete_to_continue:
      'Stripe 계정이 비활성화되어 있습니다. 계속하려면 연결하거나 활성화해 주세요.',
    connect_tripe: 'Stripe 연결',
    certificate_sent_sucessfully:
      '인증서가 이메일로 성공적으로 전송되었습니다.',
    error_try_again: '오류가 발생했습니다. 다시 시도해 주세요!',
    error_delete_channel: '채널 삭제 중 오류가 발생했습니다.',
    error_update_sub: '구독 업데이트 중 오류가 발생했습니다.',
    end_time_cannot_start: '종료 시간이 시작 시간보다 이전일 수 없습니다.',
    start_date_time_interval: '시작 날짜 및 시간 간격이 필요합니다!',
    podcast_updated_successful: '팟캐스트가 성공적으로 업데이트되었습니다.',
    podcast_created_successful: '팟캐스트가 성공적으로 생성되었습니다.',
    podcast_published_successful: '팟캐스트가 성공적으로 게시되었습니다',
    podcast_cover_updated: '팟캐스트 커버가 업데이트되었습니다',
    new_podcast_details:
      '입력한 새 정보로 현재 팟캐스트에 새 팟캐스트가 생성됩니다.',
    current_update_podcast:
      '현재 팟캐스트, 음악 및 스토리 정보를 업데이트합니다.',
    create_new_podcast: '새 팟캐스트 생성',
    publish_podcast_public_view: '팟캐스트를 공개로 게시합니다.',
    only_allowed_twenty_five_email: '이메일은 최대 25개까지만 허용됩니다.',
    only_allowed_five_email: '이메일은 최대 5개까지만 허용됩니다.',
    cover_is_required: '커버가 필요합니다.',
    topic_is_required: '주제가 필요합니다.',
    delete_schedule: '일정 삭제',
    make_as_coaching: '코칭 가능으로 표시',
    manage_category: '카테고리 관리',
    threshold: '임계값',
    threshold_popup: '해당 카테고리에 대한 추천이 활성화되는 임계값(%)입니다.',
    list_of_catagory: '카테고리 목록',
    category_name: '카테고리 이름',
    category_threshold: '카테고리 임계값',
    play_game: '게임하기',
    switching_organization: '조직 전환 중...',
    coaching_session: '코칭 세션',
    required_channel_id: '채널 ID가 필요합니다!',
    error_occured_try_again: '오류가 발생했습니다. 다시 시도해 주세요!',
    please_complete_marketplace_form: '마켓플레이스 양식을 작성해 주세요!',
    upload_file_corrupt: '업로드한 파일이 손상되었습니다.',
    course_not_published: '과정이 아직 게시되지 않았습니다!',
    error_request: '요청에 오류가 발생했습니다. 다시 시도해 주세요!',
    skill_request: '누락된 항목을 모두 입력해 주세요!',
    error_occured: '오류가 발생했습니다. 다시 시도해 주세요!',
    show_time: '시간 보기',
    start_time: '시작 시간',
    end_time: '종료 시간',
    room_name: '팟캐스트 이름',
    add_guest_speaker: '게스트 발표자 추가',
    cover_picture: '커버 사진',
    guest_speaker: '게스트 발표자',
    see_more: '더 보기',
    see_less: '간단히 보기',
    background: '배경',
    icon: '아이콘',
    icon_size: '아이콘 크기',
    icon_color: '아이콘 색상',
    only_text: '텍스트',
    change_bg: '배경색 변경',
    bg_color: '배경색',
    font_size: '글꼴 크기',
    normal: '보통',
    change_color: '텍스트 색상 변경',
    slant_text: '기울인 텍스트',
    text_radius: '텍스트 반경',
    vertical_align: '수직 정렬',
    horizontal_align: '수평 정렬',
    change_icon_color: '아이콘 색상 변경',
    upload_icon: '아이콘 업로드',
    upload_signature: '서명 업로드',
    add_another_sign: '다른 서명 추가',
    name_badges: '배지 이름',
    should_less_150: '150자 이내여야 합니다',
    your_badge: '내 배지',
    do_you_want_delete_badge: '이 배지를 삭제하시겠습니까?',
    do_you_want_delete_cert: '이 인증서를 삭제하시겠습니까?',
    upload_logo: '로고 업로드',
    name_of_cert: '인증서 이름',
    upload_cert: '인증서 업데이트',
    your_cert: '내 인증서',
    translate_to: '다음 언어로 번역',
    select_file_attach: '첨부할 파일 선택',
    certificate: '인증서',
    badge: '배지',
    publish_options: '게시 옵션',
    publish_skills_journey: '기술 여정 게시',
    videos: '비디오',
    generate_ai_video:
      'AI 비디오 생성에는 시간이 걸릴 수 있습니다. 완료되면 이메일로 알림을 받습니다.',
    trainer_information: '트레이너 정보',
    promotional_video_link: '홍보 비디오 링크',
    please_select: '선택해 주세요',
    image_name: '이미지 이름:',
    image_size: '이미지 크기:',
    charecters_fifteen_less: '15자 이내',
    leadership: '리더십',
    text_arc: '텍스트 호',
    vertical: '수직',
    horizontal: '수평',
    badge_history: '배지 이력',
    templates: '템플릿',
    sign: '서명',
    logo: '로고',
    certificate_history: '인증서 이력',
    please_wait: '잠시만 기다려 주세요...',
    information: '정보',
    support_five_thousand_live_event: '최대 5000명의 참가자를 지원합니다',
    support_ten_live_event: '최대 10명의 실시간 참가자를 지원합니다',
    we_will_back_participant:
      '더 많은 참가자가 있는 이벤트로 곧 돌아오겠습니다.',
    course_objectives: '과정 목표',
    course_outlines: '과정 개요',
    price_dollor: '가격 (USD)',
    not_completed: '미완료',
    enable_marketplace: '마켓플레이스 활성화',
    enable_course_ai: 'AI 기반 과정 생성 활성화',
    enable_report_to_admin: '관리자 보고서 보기 활성화',
    enable_white_label: '화이트 라벨 활성화',
    enable_eleven_labs_for_maze_play: 'Maze Play용 Elevenlabs 활성화',
    enable_eleven_labs_for_maze_play_cloned: '복제된 음성용 Elevenlabs 활성화',
    simulation_quiz: '시뮬레이션 퀴즈',
    bg_color_setting: '배경색 설정',
    color_preview: '색상 미리보기',
    choose_new_color: '새 색상 선택',
    remove_color: '색상 제거',
    apply_color: '색상 적용',
    elemeent_in_a_sceenario_page:
      '시나리오 페이지에는 다른 요소를 추가할 수 없습니다. 다른 페이지를 사용하거나 먼저 시나리오를 제거하세요.',
    no_data_found: '데이터가 없습니다.',
    references: '참고자료',
    open_file: '파일 열기',
    showing_result: '결과 보기:',
    fiften_day_free_trail: '15일 무료 체험',
    your_browser_does_not_support:
      '브라우저가 오디오 요소를 지원하지 않습니다.',
    podcast_desc: '팟캐스트 설명',
    input_podcast_desc: '팟캐스트 설명을 입력해주세요',
    podcast_obj: '팟캐스트 목표',
    input_podcast_obj: '팟캐스트 목표를 입력해주세요',
    podcast_outline: '팟캐스트 개요',
    input_podcast_outline: '팟캐스트 개요를 입력해주세요',
    add_file: '파일 추가',
    generate_podcast_audio: '팟캐스트 오디오 생성',
    generate_uploaded_file_input_parameter:
      '업로드된 파일과 입력한 매개변수를 기반으로 콘텐츠를 생성합니다.',
    go_backe_generation_state: '콘텐츠 생성 상태로 돌아가기',
    create_ai_powered_podcast:
      '생성된 오디오로 AI 기반의 팟캐스트 에피소드를 생성하세요.',
    generate_voice_for_all_podcast:
      '모든 팟캐스트 에피소드에 대한 음성을 생성해주세요',
    create_podcast_episode: '팟캐스트 에피소드 생성',
    voice_name: '음성 이름',
    input_custom_name: '사용자 정의 이름을 입력해주세요!',
    enter_custom_name: '사용자 정의 음성 이름을 입력하세요',
    upload_complete: '업로드 완료',
    uploading_in_progress: '업로드 진행 중...',
    podcast_stream_content: '팟캐스트 스트리밍 콘텐츠',
    upload_podcast_cover: '팟캐스트 커버를 업로드해주세요!',
    enter_podcast_name: '팟캐스트 이름을 입력해주세요!',
    podcast_topic: '팟캐스트 주제',
    enter_podcast_topic: '팟캐스트 주제를 입력해주세요!',
    enter_podcast_desc: '팟캐스트 설명을 입력해주세요!',
    number_of_speaker: '화자 수',
    select_the_number_of_speaker: '화자 수를 선택해주세요!',
    number_of_episode: '에피소드 수',
    input_number_of_episode: '에피소드 수를 입력해주세요!',
    podcast_length: '팟캐스트 길이',
    select_the_podcast_length: '팟캐스트 길이를 선택해주세요!',
    short_podcast: '짧음 (5~10분)',
    medium_podcast: '중간 (15~18분)',
    long_podcast: '김 (18분 이상)',
    name_of_host: '호스트 이름',
    enter_host_name: '호스트 이름을 입력해주세요!',
    guest_name: '게스트 이름',
    enter_guest_name: '게스트 이름을 입력해주세요!',
    choose_speaker_tone: '화자의 말투 선택',
    enter_speaker_tone: '팟캐스트의 말투를 선택해주세요!',
    informal: '비격식',
    formal: '격식',
    serious: '진지한',
    light_humor: '가벼운 유머',
    casual: '캐주얼',
    select_content_source: '콘텐츠 소스 선택',
    from_internet: '인터넷에서',
    upload_pdf_internet: 'PDF 또는 내부 문서 업로드',
    note: '참고:',
    podcast_content_will_be_automatically_generated:
      '팟캐스트 콘텐츠는 신뢰할 수 있는 인터넷 소스를 기반으로 자동 생성됩니다.',
    upload_or_select_file: '파일을 업로드하거나 선택해주세요!',
    podcast_eposode_title: '팟캐스트 에피소드 제목',
    enter_podcast_title: '에피소드 제목을 입력해주세요!',
    podcast_episode_des: '팟캐스트 에피소드 설명',
    enter_podcast_episode_des: '에피소드 설명을 입력해주세요!',
    voice: '음성',
    music: '음악',
    select_music: '음악 선택',
    play_the_music: '음악 재생',
    stop_the_music: '음악 정지',
    context: '맥락',
    generate_audio_content_selected_voice:
      '선택한 음성에 따라 오디오 콘텐츠를 생성합니다.',
    required_field_before_submitting: '제출 전 모든 필수 항목을 작성해주세요.',
    regenerate_voice: '음성 재생성',
    generate_voice: '음성 생성',
    your_browser_does_not_suppot: '브라우저가 오디오 요소를 지원하지 않습니다.',
    are_sure_leave_podcast: '정말 팟캐스트를 떠나시겠습니까?',
    broadcast_ongoing: '방송이 진행 중입니다. 정말 이 페이지를 나가시겠습니까?',
    brodcaster_unavailable: '현재 방송자가 사용 불가능합니다.',
    setting_calender_for_booking: '예약을 위한 캘린더 설정 중',
    add_calender: '캘린더 추가',
    waiting_join_host: '호스트 참가를 기다리는 중...',
    no_reviews_found: '리뷰가 없습니다.',
    rated_already: '이미 이 라이브 이벤트를 평가하셨습니다.',
    downlink_png: 'PNG 다운로드',
    downlink_jpg: 'JPG 다운로드',
    donwload_file_format: '다운로드할 파일 형식을 선택해주세요.',
    crashed_event:
      '이 이벤트는 문제가 발생했습니다. 새 이벤트를 생성해주세요. 불편을 드려 죄송합니다.',
    prompt: '프롬프트:',
    generated_image: '🚀 이미지를 생성 중입니다... 잠시만 기다려 주세요.',
    download_add: '전체 다운로드',
    setting_generator: '생성기 설정',
    enter_image_prompt: '이미지 프롬프트를 입력해주세요',
    image_prompt: '이미지 프롬프트 입력',
    negative_prompt: '부정 프롬프트',
    negative_image_prompt: '부정적인 이미지 프롬프트를 입력하세요',
    number_output: '출력 개수',
    enter_number_output: '출력 개수를 입력하세요',
    image_style: '이미지 스타일을 선택해주세요',
    output_format: '출력 형식',
    seeds: '시드',
    enter_seeds: '시드 수를 입력하세요',
    performance_mode: '성능 모드',
    quality: '품질',
    speed: '속도',
    balanced: '균형',
    guidance_scale: '가이던스 스케일',
    enter_guidance: '가이던스 스케일을 입력하세요',
    select_image: '이미지를 선택하세요.',
    image_prmt: '이미지 프롬프트',
    generate_image_list_empty: '생성된 이미지 목록이 비어 있습니다.',
    knowledge_center_tooltrip_des:
      '일반적인 지식 질문을 포함하여 다양한 질문에 대해 간결하고 맥락에 맞는 정확한 응답을 받습니다. 응답은 다양한 인터넷 텍스트로 훈련된 AI 모델이 일반 인터넷 정보에서 얻습니다.',
    contexts: '컨텍스트',
    ai_processing_video_sharebot:
      'Sharebot에서 비디오 처리에는 약 24시간이 소요됩니다.',
    remove_sharebot_video:
      'Sharebot에서 비디오 참조를 제거하려면 해당 영상과 함께 대본을 삭제해주세요.',
    remove_sharebot_video_audio:
      '대본을 삭제하면 해당 Sharebot의 비디오/오디오 참조도 제거되지만, 미디어 라이브러리/채널에는 여전히 표시됩니다.',
    monthly_live_stream: '월간 라이브 스트리밍 제한을 변경하려면 연락해주세요',
    monthly_transcribe_limit: '월간 전사 제한을 변경하려면 연락해주세요',
    must_be_one_to_three_hundred: '1분에서 300분 사이여야 합니다.',
    all_field_required: '모든 항목은 필수입니다.',
    duration_minute: '길이 (최대 300분)',
    gender: '성별',
    select_gender: '성별 선택',
    accent: '억양',
    select_accent: '억양 선택',
    create_voice: '음성 만들기',
    enter_voice_name: '음성 이름 입력',
    select_voice_gender: '음성 성별을 선택하세요',
    upload_voice: '음성 업로드',
    upload_voice_mp_three: '음성을 업로드하세요 (.mp3)',
    cloned_voice: '복제된 음성',
    voice_type: '음성 유형',
    select_voice_type: '음성 유형 선택',
    sharelook_stand: '표준',
    sharelook_premium: '프리미엄',
    sharelook_custum_voice: '사용자 지정 (음성 복제)',
    create_auto_flow: '자동 흐름 만들기',
    how_many_layers: '레이어 수',
    verify_selection: '선택 확인',
    uploaded_successful: '업로드 성공',
    upload_failed: '업로드 실패',
    upload_only_five_mb: '콘텐츠 업로드 (PDF 파일, 최대 5개)',
    docs_from_org_library: '조직 라이브러리에서 문서 사용',
    failed_maze_generate: '미로 생성 실패. 다시 시도해주세요.',
    generate_metamaze: '메타미로 생성 중...',
    metamaze_being_generated:
      '메타미로가 생성 중입니다. 완료되면 이메일로 알려드리겠습니다.',
    metamaze_generate_successfully: '메타미로가 성공적으로 생성되었습니다!',
    metamaze_with_proceed: '이제 메타미로를 진행할 수 있습니다.',
    ai_metamaze_generate: 'AI 메타미로 생성',
    what_kind_maze_create: '어떤 종류의 미로를 만들고 싶으신가요?',
    manual_metamaze_creation: '수동 메타미로 생성',
    manually_maze_customizing_scnario:
      '시나리오와 옵션 트리를 사용자 정의하여 미로를 수동으로 생성',
    maze_ai_generated: 'AI로 자동 생성된 미로',
    unmark_deadend: '막다른 길 해제',
    mark_deadend: '막다른 길로 표시',
    select_multiple_image_for_scenario:
      '시나리오에 여러 이미지를 선택할 수 있습니다.',
    select_your_image: '선택한 이미지',
    click_to_preview: '클릭하여 미리보기',
    are_you_sure_delete_image: '이 이미지를 삭제하시겠습니까?',
    select_image_from_library: '미디어 라이브러리에서 이미지 선택',
    uploading_video: '비디오 업로드 중...',
    tree_node_type: '트리 노드 유형',
    correct_option_scenario: '정답 옵션 또는 시나리오',
    incorrect_option: '오답 옵션',
    option_scenario_without_text: '텍스트가 없는 옵션 또는 시나리오',
    dead_end: '막다른 길 (빨간 테두리)',
    correct_path: '정답 경로',
    incorrect_path_not_selected_correct_option_path:
      '정답 옵션이 선택되지 않은 오답 경로',
    double_click_on_tree_node:
      '트리 노드를 더블 클릭하면 해당 노드의 콘텐츠가 자동으로 표시됩니다.',
    add_scenario: '시나리오 추가',
    add_option: '옵션 추가',
    an_error_occured: '오류가 발생했습니다:',
    download_summary: '요약 다운로드',
    step_wise_analysis: '단계별 분석',
    step: '단계',
    upload_csv_file: 'CSV 파일 업로드',
    download_template_to_import: '가져오기용 샘플 템플릿 다운로드',
    please_input_email: '이메일을 입력해주세요.',
    email_at_least_three_characters: '이메일은 최소 3자 이상이어야 합니다.',
    email_cannot_be_empty: '이메일은 비워둘 수 없습니다.',
    input_email_in_new_line: '각 이메일은 새로운 줄에 입력해주세요',
    role: '역할',
    select_role: '역할을 선택해주세요',
    select_group: '그룹을 선택해주세요',
    identification_number: '식별 번호 (선택 사항)',
    add_identification_number: '식별 번호를 입력해주세요',
    pie_chart_of_all_categories:
      'Sharelook에서의 사용 기반 모든 카테고리의 파이 차트입니다.',
    total_sharesphere_question_answered_by_users:
      '현재 조직에서 사용자가 응답한 모든 ShareSphere 질문의 총합과 카테고리별 성공 및 실패 결과입니다.',
    voice_style_over_the_text:
      '입력한 텍스트 위에 다양한 음성 스타일을 적용할 수 있습니다. 예: Lorem Ipsum은 인쇄 및 조판 업계의 더미 텍스트입니다.',
    input_your_question: '질문을 입력해주세요!',
    make_me_sales_manager: '예: 어떻게 하면 영업 관리자가 될 수 있을까요?',
    enter_the_number_relevant_document: '관련 문서 수를 입력하세요',
    please_wait_loading_result:
      '결과를 불러오는 중입니다. 잠시만 기다려주세요...',
    no_result_found: '결과가 없습니다. 다른 질문을 해보세요.',
    browser_doesnot_support_iframes: '브라우저가 iframe을 지원하지 않습니다',
    total_duration: '총 소요 시간',
    number_of_messages: '메시지 수',
    search_result: '검색 결과',
    count_result: '(1244건의 결과)',
    your_other_interests: '다른 관심사',
    your_total_score: '총 점수',
    add_a_question: '+질문 추가',
    travia_question_empty: '트라비아 질문 목록이 비어 있습니다.',
    video_generation_is_on_queue: '비디오 생성이 대기 중입니다!',
    checking_video_status: '비디오 상태 확인 중...',
    total_quizzes: '총 퀴즈 수',
    number_of_votes: '투표 수',
    total_events: '총 이벤트 수',
    number_of_rates: '평가 수',
    number_of_likes: '좋아요 수',
    all_courses: '모든 강좌',
    total_questions: '총 질문 수',
    no_skill_journey: '이용 가능한 스킬 여정이 없습니다!',
    search_no_results: '- 검색 결과가 없습니다!',
    no_image_generated: '생성된 이미지가 없습니다!',
    all_topic_in_this_lesson:
      '이 강의의 모든 주제가 삭제됩니다. 이 작업은 되돌릴 수 없습니다.',
    content_has_been_generated: '이 주제에 대한 콘텐츠가 생성되었습니다.',
    update_course_template: '강좌 템플릿 업데이트',
    add_course_template: '강좌 템플릿 추가',
    create_course_now: '지금 강좌 만들기',
    preview_course: '강좌 미리보기',
    layout: '레이아웃',
    import_from_youtube: '유튜브에서 가져오기',
    my_media_library: '내 미디어 라이브러리',
    bg_added: '배경 추가됨',
    add_bg: '배경 추가',
    booked_schedule: '예약된 일정',
    add_schedule: '일정 추가',
    are_you_delete_schedule: '이 일정을 삭제하시겠습니까?',
    add_task: '작업 추가',
    update_calender: '달력 업데이트',
    manage_cookies: '쿠키 관리',
    cookie_banner_text:
      '우리는 브라우징 경험을 향상시키고, 웹사이트 트래픽을 분석하며, 콘텐츠를 개인화하기 위해 쿠키를 사용합니다. 귀하의 개인정보는 중요합니다.',
    accept_all_cookies: '모든 쿠키 허용',
    reject_all: '모두 거부',
    customize: '맞춤 설정',
    cookie_preferences_title: '쿠키 설정 및 개인정보 보호 설정',
    privacy_subtitle:
      '귀하의 개인정보는 중요합니다. 허용할 쿠키를 선택하세요. 이 설정은 언제든지 변경할 수 있습니다.',
    save_choices: '내 선택 저장',
    strictly_necessary: '필수 쿠키',
    strictly_necessary_desc:
      '이 쿠키는 웹사이트가 정상적으로 작동하는 데 필수적입니다. 페이지 탐색, 양식 제출, 보안 영역 접근과 같은 기본 기능을 활성화합니다. 이 쿠키 없이는 웹사이트가 제대로 작동하지 않습니다.',
    analytics_performance: '분석 및 성능',
    analytics_performance_desc:
      '이 쿠키는 방문자가 웹사이트와 상호작용하는 방식을 익명으로 수집하고 보고함으로써 이해하는 데 도움을 줍니다. 이를 통해 웹사이트 성능과 사용자 경험을 개선할 수 있습니다.',
    advertising_marketing: '광고 및 마케팅',
    advertising_marketing_desc:
      '이 쿠키는 광고 메시지를 귀하에게 더 관련성 있게 표시하는 데 사용됩니다. 동일한 광고가 반복적으로 나타나는 것을 방지하고 광고가 올바르게 표시되도록 합니다.',
    tracking_social: '추적 및 소셜 미디어',
    tracking_social_desc:
      '이 쿠키는 소셜 미디어 기능 및 개인화된 콘텐츠와 같은 향상된 기능을 가능하게 합니다. 당사 또는 제3자 제공자가 설정할 수 있습니다.',
    functional: '기능 쿠키',
    functional_desc:
      '이 쿠키는 채팅 지원, 라이브 도움말 및 웹사이트 경험을 개선하는 기타 인터랙티브 기능과 같은 향상된 기능을 제공합니다.',
    your_rights: '귀하의 권리:',
    rights_description:
      '귀하는 언제든지 동의를 철회하거나, 데이터에 접근하거나, 삭제를 요청할 수 있습니다.',
    withdraw_consent: '모든 동의 철회',

    how_many_options: '옵션 수',
    add_content: '콘텐츠 추가',
    downloads_center: '다운로드 센터',
    sharelook_help_center: 'Sharelook 도움말 센터',
    channel_outline: '채널 개요',
    channel_objectives: '채널 목표',
    no_sop_available: '사용 가능한 SOP 목록이 없습니다.',
    generate_world_summary: '시나리오 생성',
    world_scenario: '실제 시나리오',
    drag_icon_hint: '팁: 아이콘을 캔버스로 드래그하여 위치 지정',
    drag_text_hint: '팁: 텍스트를 캔버스로 드래그하여 위치 지정',
    edit_badge: '배지 편집',
    create_new_badge: '새 배지 생성',
    select_video_preview: '미리보기할 비디오 선택',
    certificate_title_required: '인증서 제목이 필요합니다',
    discard_changes: '변경 사항 취소',
    edit_certificate: '인증서 편집',
    add_another_logo: '다른 로고 추가',
    optional: '선택 사항',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: '새 퀘스트 생성',
    quest_filter_title: '퀘스트',
    sharelook_assistance: 'Sharelook 코칭',
    upload_scorm_zip: 'SCORM ZIP 업로드',
    only_letters_numbers_space_dot_allowed:
      '허용되는 문자: 영어, 숫자, 공백, 점(.)',
    video_playing: '재생 중',
    course_price_message: `*이 코스는 조직 내 사용자에게만 게시되며 마켓플레이스에서 재판매할 수 없습니다.`,
    lesson_must_be_positive: '레슨 수는 1보다 커야 합니다',
    btn_proceed: '진행',
    rule_select_music: '음악을 선택하세요',
    course_info: '코스 정보',
    content_selection: '콘텐츠 선택',
    course_content_source: '코스 콘텐츠 출처',
    choose_how_to_source: '이 코스의 콘텐츠를 가져오는 방법 선택:',
    automatic_selection: '자동 선택',
    system_will_automatically_select_relavant_documents:
      '시스템이 라이브러리에서 관련 문서를 자동으로 선택합니다',
    manual_selection: '수동 선택',
    choose_specific_documents_from_your_library:
      '라이브러리에서 특정 문서 선택',
    upload_files: '파일 업로드',
    upload_new_documents:
      '새 문서 업로드(PDF, DOC, DOCX, PPT, PPTX, TXT) - 최대 5개 파일',
    file: '파일',
    ready_to_upload: '업로드 준비 완료',
    clear_all: '전체 지우기',
    confirm_course_wide_premiew: '코스 전체 미리보기 확인',
    generate_course_preview: '코스 미리보기 생성',
    instructions_across_the_course_to_generate:
      '지침을 코스 전체에 적용하여 미리보기를 생성합니다. 저장 또는 취소하기 전에 모두 검토하세요.',
    instruction_to_preview_course_wide: '코스 전체 미리보기 지침:',
    edit_content: '콘텐츠 편집',
    manage_course_template: '코스 템플릿 관리',
    undo: '실행 취소',
    apply_changes: '변경 사항 적용',
    characters: '문자 수',
    apply_all: '전체 적용',
    apply_to_all: '모두 적용',
    use_this_content: '이 콘텐츠 사용',
    original: '원본',
    edited: '편집됨',
    edited_content_preview: '편집된 콘텐츠 미리보기',
    apply_edits_to_all_topices: '모든 주제에 편집 적용?',
    current_editing_instructions_across_the_whole_course:
      '현재 편집 지침을 코스 전체에 적용합니다. 저장하기 전에 통합 미리보기를 검토할 수 있습니다.',
    edit_content_instructions: '콘텐츠 편집 지침',
    generate_content_for_this_topic_instruction:
      '지침에 따라 이 주제의 콘텐츠 생성',
    descrip_edit_content:
      '콘텐츠 편집 방법 설명(예: 줄이기, 단순화, 다시 작성)',
    try_short_clear_direcctives: `짧고 명확한 지침 사용. 예: "핵심만 남기고 100단어로 줄이기", "언어 단순화", "불필요한 내용 제거하고 간결하게".`,
    we_preserve_the_core_meaning: '지침 적용 시 핵심 의미를 보존합니다.',
    feedback_optional: '피드백(선택)',
    write_your_feedback_here: '여기에 피드백 작성',
    from_web: '웹에서',
    from_desktop: '데스크탑에서',
    pleae_wait_processing: '처리 중입니다. 잠시 기다려주세요...',
    create_simulation_from_screen_capture: '화면 캡처에서 시뮬레이션 생성',
    sharelook_not_found: 'ShareLook을 찾을 수 없음',
    sharelook_screen_capture_application_not_be_opened:
      'ShareLook 화면 캡처 애플리케이션을 열 수 없습니다. 컴퓨터에 설치되어 있지 않을 수 있습니다.',
    download_sharelook: 'ShareLook 다운로드',
    launch_sharelook_application: 'ShareLook 앱 실행',
    this_will_open_the_sharelook_application_for_screen_capture:
      '화면 캡처를 위해 ShareLook 앱을 엽니다.',
    sharelook_dosenot_open:
      'ShareLook이 열리지 않으면 컴퓨터에 설치되어 있지 않을 수 있습니다.',
    open_sharelook: 'ShareLook 열기',
    download_app: '앱 다운로드',
    background_image_setting: '배경 이미지 설정',
    current_image: '현재 이미지',
    change_image: '이미지 변경',
    remove_image: '이미지 제거',
    no_background_image_selected: '선택된 배경 이미지가 없습니다',
    add_image: '이미지 추가',
    this_will_open_for_screen_recording:
      '화면 녹화를 위해 ShareLook 앱을 엽니다.',
    ai_image_generation: 'AI 이미지 생성',
    image_edit: '이미지 편집',
    text_to_image: '텍스트 → 이미지',
    output_gallary: '출력 갤러리',
    instant_generation: '즉시 생성 가능',
    prompt_and_unleash_the_power: '프롬프트를 입력하고 AI의 힘을 활용하세요',
    use_this_image: '이 이미지 사용',
    error_generating: '생성 중 오류 발생',
    generation_tips: '생성 팁',
    detailed_descriptions_for_more_accurate_results:
      '보다 정확한 결과를 위해 상세한 설명 사용',
    reference_image: '참조 이미지',
    select_pixel_image: '픽셀 이미지 선택',
    max_mb: '최대 50MB',
    please_enter_text_to_appear_image: '이미지에 표시될 텍스트 입력',
    enter_text_to_apear_in_the_image: '이미지에 표시될 텍스트 입력',
    generate_image: '이미지 생성',
    prompt_assistant: '프롬프트 도우미',
    generate_image_using_suggested_prompt: '추천 프롬프트로 이미지 생성',
    talk_to_ai_about_the_image_generate: '생성할 이미지에 대해 AI와 대화',
    ask_for_prompt_suggestions: '프롬프트 제안 요청...',
    enter_a_search_term_to_find_stock_images: '스톡 이미지 검색어 입력',
    choose_your_content_source: '콘텐츠 소스 선택:',
    upload_new_document_from_your_device: '기기에서 새 문서 업로드',
    automatic_library_selection: '자동 라이브러리 선택',
    system_automatically_selects_relevant_document:
      '시스템이 관련 문서를 자동으로 선택합니다',
    manual_library_selection: '수동 라이브러리 선택',
    generate_content: '콘텐츠 생성',
    add_to_current_page: '현재 페이지에 추가',
    generate_bullet_points: '글머리표 생성',
    generating: '생성 중',
    this_may_take_a_few_moments: '잠시 시간이 걸릴 수 있습니다',
    apply_to_page: '페이지에 적용',
    scenario_escription: '시나리오 설명:',
    feedback: '피드백',
    form_mode: '폼 모드',
    chat_mode: '채팅 모드',
    this_will_generate_a_continuation_of_the_seleccted_story:
      '선택한 스토리의 이어지는 내용을 AI로 생성합니다.',
    continue_this_story_question: '이 스토리를 계속하시겠습니까?',
    continue_this_story: '스토리 이어가기',
    what_will_happen: '무슨 일이 일어날까요:',
    the_ai_will_analyze_the_existing_story_content:
      'AI가 기존 스토리 내용을 분석합니다',
    generate_a_natural_continuation_that_follows_the_same_tone:
      '같은 톤과 스타일을 따라 자연스러운 이어지는 내용 생성',
    create_new_content_that_build_upon_the_current_narrative:
      '현재 이야기 기반으로 새로운 콘텐츠 생성',
    this_process_may_take_a_few_moments_to_complete:
      '이 과정은 완료까지 잠시 시간이 걸릴 수 있습니다.',
    no_existing_stories_found_for_this_course:
      '이 과정에는 기존 스토리가 없습니다.',
    create_your_first_story: '첫 번째 스토리 만들기',
    existing_stories: '기존 스토리',
    create_new_story: '새 스토리 만들기',
    tone: '톤',
    style: '스타일',
    genre: '장르',
    loading_your_stories: '스토리 불러오는 중...',
    edit_story: '스토리 편집',
    story_preferences: '스토리 설정',
    please_input_your: '입력해주세요',
    add_character_names_and_press_enter:
      '캐릭터 이름을 추가하고 Enter를 누르세요',
    select_or_type_your: '선택하거나 입력하세요',
    enter_your: '입력하세요',
    position_of_the_story_in_the_lesson:
      '레슨 내 스토리 위치. 지정한 위치에 블록으로 스토리가 추가됩니다.',
    save_previous_content_on_the_pages: '이전 페이지 내용 저장',
    the_existing_content_in_the_selected_pages:
      '선택한 페이지의 기존 내용은 생성된 스토리로 대체됩니다.',
    real_world_scenario: '현실 시나리오',
    add_optional_instructions: '선택적 지침 추가 (톤, 길이, 대상 등)',
    ready_to_enerate_your_real_world_scenario:
      '현실 시나리오를 생성할 준비 완료',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      '"현실 시나리오 생성"을 클릭하여 레슨 내용을 기반으로 현실적인 시나리오를 만드세요.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'AI가 레슨 주제와 내용을 분석합니다',
    generate_a_practical_real_world_scenario: '실용적인 현실 시나리오 생성',
    you_can_then_edit_and_customize_the_result:
      '결과를 편집하고 맞춤화할 수 있습니다',
    add_it_as_a_new_page_to_your_lesson: '레슨에 새 페이지로 추가',
    regenerate_with_instructions: '지침과 함께 재생성',
    add_real_world_scenario: '현실 시나리오 추가',
    generate_real_world_scenario: '현실 시나리오 생성',
    simulation_has_been_stopped: '시뮬레이션이 중지되었습니다!',
    loading_simulation: '시뮬레이션 로딩 중...',
    you_have_exhausted_all_the_attempts: '모든 시도를 소진했습니다',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      '이 페이지의 시나리오를 확인하고 아래 옵션에서 올바른 답변을 선택하세요.',
    attempts_limit_reached:
      '시도 한도에 도달했습니다. 다시 플레이할 수 있지만 점수는 저장되지 않습니다.',
    play_again: '다시 플레이',
    import_music_from_computer: '컴퓨터에서 음악 가져오기',
    more: '더보기',
    no_badge_yet: '아직 배지가 없습니다',
    competition_filter: '경쟁 필터',
    global_leaderboard: '글로벌 리더보드',
    placeholder_for_the_global_leaderboard:
      '글로벌 리더보드 자리 표시자입니다.',
    badge_editor: '배지 편집기',
    adjust_the_appearance_of_this_badge_icon:
      '이 배지 아이콘의 모양을 조정합니다. 변경 사항은 이 배지에만 적용됩니다.',
    badge_style: '배지 스타일',
    the_image_must_be_pixels: '이미지는 200x200픽셀이어야 합니다.',
    badge_name: '배지 이름',
    badge_descrription: '배지 설명',
    enter_badge_criteria: '배지 기준 입력',
    discard: '버리기',
    badge_enable: '배지 활성화',
    award_users_with_badges_to_highlight_the_milestones:
      '학습자의 주요 성취를 강조하기 위해 배지를 부여합니다.',
    badge_types: '배지 유형',
    enable_or_disable_specific_badge_types_for_your_users:
      '사용자를 위해 특정 배지 유형을 활성화하거나 비활성화합니다.',
    levels_enabled: '레벨 활성화',
    level_rules: '레벨 규칙',
    points: '포인트',
    add_new_level: '새 레벨 추가',
    add_level: '레벨 추가',
    points_enabled: '포인트 활성화',
    learning_activities_and_encourage_healthy_competition:
      '다양한 학습 활동에 대해 포인트를 부여하고 건강한 경쟁을 장려합니다.',
    award_points: '포인트 부여',
    the_following_equates_the_value_of_one_item_completion:
      '다음은 한 항목 완료 값에 해당합니다',
    general: '일반',
    others: '기타',
    certificate: '인증서',
    quiz_passed: '퀴즈 통과',
    tip_approved: '팁 승인됨',
    tip_liked: '팁 좋아요',
    rewards: '보상',
    offer_discounts_when_learners_achieve:
      '학습자가 일정 포인트, 배지 또는 레벨을 달성하면 할인 제공',
    give_rewards: '보상 제공',
    discount_course_purchases_by: '강좌 구매 할인',
    with_points_more_than: '포인트 이상',
    with_badges_more_than: '배지 이상',
    with_level_upwards_more_than: '레벨 이상',
    leaderboard: '리더보드',
    leaderboard_enabled: '리더보드 활성화',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      '리더보드는 사용자가 다른 사람과 비교하여 학습 진행 상황을 볼 수 있도록 제공합니다.',
    show_levels: '레벨 표시',
    show_points: '포인트 표시',
    show_badges: '배지 표시',
    show_courses: '강좌 표시',
    show_certificates: '인증서 표시',
    leaderboard_settings: '리더보드 설정',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      '사용자의 학습 동기를 높이는 참여형 리더보드 환경 설정',
    award_users_with_points_for_different_learning_activities:
      '다양한 학습 활동에 대해 포인트를 부여합니다.',
    badge_set: '배지 세트',
    choose_the_type_of_badges_your_users:
      '사용자가 학습하면서 획득할 배지 유형 선택',
    levels: '레벨',
    Levels_represent_the_stages: '레벨은 사용자의 학습 단계를 나타냅니다.',
    enabled: '활성화됨',
    disabled: '비활성화됨',
    quick_select: '빠른 선택',
    yesterday: '어제',
    last_week: '지난주',
    Last_month: '지난달',
    last_quarter: '지난 분기',
    historical_leaderboard: '과거 리더보드',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      '성과를 추적하고 동료들 사이에서 순위를 확인하세요',
    time_period: '기간',
    page_of: '페이지 1 / 1',
    edit_competition: '경쟁 편집',
    create_competition: '경쟁 생성',
    arrow_right: '오른쪽 화살표',
    update_competition: '경쟁 업데이트',
    competition_title: '경쟁 제목',
    enter_competition_title: '경쟁 제목 입력',
    enter_competition_description: '경쟁 설명 입력',
    leaderboard_skill: '스킬',
    select_a_skill: '스킬 선택',
    no_skills_found: '스킬 없음',
    competition_period: '경쟁 기간',
    add_badge_rule: '배지 규칙 추가',
    create_badge: '배지 생성',
    add_level_rule: '레벨 규칙 추가',
    selected_participants: '선택된 참가자',
    no_participants: '참가자 없음',
    start_end_date: '시작–종료일',
    created_date: '생성자',
    new_competition: '새 경쟁',
    competitions_list: '경쟁 목록',
    search_competitions: '경쟁 검색...',
    are_you_sure_you_want_to_delete_the_competition:
      '이 경쟁을 삭제하시겠습니까?',
    history: '히스토리',
    export: '내보내기',
    search_by_name: '이름으로 검색...',
    no_historical_data_available_for_the_selected_period:
      '선택한 기간의 과거 데이터가 없습니다.',
    no_leaderboard_data_available: '리더보드 데이터 없음',
    competitions: '경쟁',
    leaderboards: '리더보드',
    welcome_back: '환영합니다',
    track_your_performance_and_see:
      '성과를 추적하고 동료들 사이에서 순위를 확인하세요',
    team_leaderboard: '팀 리더보드',
    try_again: '다시 시도',
    no_competitions_for_search: '검색된 경쟁 없음',
    no_competitions_available: '사용 가능한 경쟁 없음',
    no_competitions_matching_search:
      '검색과 일치하는 경쟁이 없습니다. 검색어를 변경하거나 나중에 다시 확인하세요.',
    no_competitions_general:
      '현재 설정된 경쟁이 없습니다. 나중에 확인하거나 관리자에게 문의하세요.',
    media_management: '미디어 관리',
    badgess_set: '배지 세트',
    choose_the_default_visual_style_for_badge:
      '플랫폼에서 사용되는 배지 아이콘의 기본 시각적 스타일 선택',
    enable_badges: '배지 활성화',
    add_badge: '배지 추가',
    min: '최소',
    max: '최대',
    your_rank: '당신의 순위',
    your_points: '당신의 포인트',
    your_level: '당신의 레벨',
    rank: '순위 #',
    level: '레벨',
    progress: '진행 상황',
    new_folder: '새 폴더',
    file_upload: '파일 업로드',
    writer: '작성자',
    text_documents: '문서',
    spreadsheets: '스프레드시트',
    impress: 'Impress',
    presentations: '프레젠테이션',
    capture_desktop_screen: '데스크탑 화면 캡처',
    capture_desktop_screens: '데스크탑 화면 캡처',
    your_documents: '내 문서',
    manage_your_videos_images_audio_files:
      '콘텐츠 제작에 사용하는 동영상, 이미지, 오디오 파일 등을 관리합니다.',
    your_organization_documents: '조직 문서',
    keep_your_organization_creative_assets_organized:
      '조직의 크리에이티브 자산을 정리하고 접근 가능하게 유지하여 팀워크와 콘텐츠 제작을 효율화합니다.',
    your_public_documents: '공개 문서',
    curated_collection_of_media_assets_available:
      '모두가 사용할 수 있는 큐레이션된 미디어 자산—탐색, 재사용 및 제작 가능',
    your_download_center_documents: '다운로드 센터 문서',
    repository_of_approved_media_assets_for_download:
      '프로젝트에서 사용할 수 있는 승인된 미디어 자산 저장소',
    search_files_and_folders: '파일 및 폴더 검색...',
    home: '홈',
    folders: '폴더',
    folder_name: '폴더 이름',
    owner: '소유자',
    last_updated: '마지막 업데이트',
    action: '작업',
    no_folders_found: '폴더가 없습니다',
    files: '파일',
    enabling_ai: 'AI 활성화 중...',
    rename: '이름 변경',
    copy: '복사',
    move: '이동',
    verson_history: '버전 기록',
    manage_permission: '권한 관리',
    generate_audit_report: '감사 보고서 생성',
    last_edited: '마지막 편집',
    no_files_found: '파일이 없습니다',
    are_you_sure_you_want_to_make_this_item_public:
      '이 항목을 공개하시겠습니까? 공개 라이브러리에 복사됩니다.',
    move_to_organization: '조직으로 이동',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      '이 항목을 조직 라이브러리에 복사하시겠습니까?',
    are_you_sure_you_want_to_make_this_item_private:
      '이 항목을 비공개로 하시겠습니까? 개인 라이브러리에 복사됩니다.',
    date_modified: '수정일',
    workflow_management: '워크플로 관리',
    configure_editors_approvers_and_viewers_for_this_document:
      '이 문서의 편집자, 승인자, 뷰어를 설정합니다.',
    error_Loading_editor: '편집기 로드 오류',
    debug_info: '디버그 정보',
    loading_editor: '편집기 로딩 중...',
    submitted_for_review: '검토 제출됨',
    editors: '편집자',
    no_editors_added_yet:
      '편집자가 아직 추가되지 않았습니다. "편집자 추가"를 클릭하여 추가하세요.',
    add_editor: '편집자 추가',
    approvers: '승인자',
    no_approvers_added_yet:
      '승인자가 아직 추가되지 않았습니다. "승인자 추가"를 클릭하여 추가하세요.',
    add_approvers: '승인자 추가',
    viewer: '뷰어',
    no_viewers_added_yet:
      '뷰어가 아직 추가되지 않았습니다. "뷰어 추가"를 클릭하여 추가하세요.',
    add_viewer: '뷰어 추가',
    are_you_sure_you_want_to_delete_the_selected_items:
      '선택한 항목을 삭제하시겠습니까?'
  },
  v3: {
    reportShareSphere: '셰어스피어',
    overview: '카테고리 개요',
    triviaReport: '셰어스피어 카테고리',
    overviewGraph: '카테고리 개요 그래프',
    category: '카테고리',
    phCategory: '카테고리 선택',
    podcast: '팟캐스트, 음악 및 스토리',
    pastPodcast: '지난 팟캐스트',
    upcomingPodcast: '예정된 팟캐스트',
    podcastLanguageTitle: '팟캐스트, 음악 및 스토리 언어',
    podcastLanguageCheckbox: '내 팟캐스트에 AI 생성 언어 사용',
    howRate: '이 팟캐스트를 어떻게 평가하시겠습니까?',
    podcastSubmit: '제출',
    podcastGuest: '게스트 스피커:',
    podcastReview: '리뷰',
    podcastEpishode: '에피소드',
    podcastEnd: '팟캐스트가 종료되었습니다',
    date_podcast: '팟캐스트 날짜',
    skill_not_found: '죄송합니다! 스킬 여정을 찾을 수 없습니다.',
    coaching: '코칭',
    webinar: '웨비나',
    public_conference: '공개 컨퍼런스',
    skill_journey_subtitle:
      '스킬 여정 설정을 추가하고 스킬 여정을 볼 수 있고 상호작용할 수 있는 대상을 선택하세요.',
    enable_white_label: '화이트 라벨 활성화',
    create_new_event_org: '조직을 위한 새 이벤트 생성',
    create_new_event_marketplace: '마켓플레이스를 위한 새 이벤트 생성',
    create_new_event_both: '조직과 마켓플레이스를 위한 새 이벤트 생성',
    event_outline: '이벤트 개요를 입력하세요',
    event_obj: '이벤트 목표를 입력하세요',
    event_description: '이벤트 설명을 입력하세요',
    create_new_metamaze_org: '조직을 위한 새 메타미로 생성',
    create_new_metamaze_marketplace: '마켓플레이스를 위한 새 메타미로 생성',
    create_new_metamaze_both: '조직과 마켓플레이스를 위한 새 메타미로 생성',
    add_key_words: '키워드 추가',
    press_enter_make_keyword: '키워드를 만들려면 Enter 키를 누르세요',
    disable_skip_quiz: '퀴즈 건너뛰기 비활성화',
    warning_complete_quiz: '진행하려면 퀴즈를 완료하세요.',
    signup_email_verification:
      '입력하신 이메일 주소로 인증 링크를 보냈습니다. 해당 링크를 방문해 등록을 확인하세요.',
    verifying_registration: '계정 등록 확인 중...',
    reset_password_linK:
      '입력하신 이메일 주소로 비밀번호 재설정 링크를 보냈습니다. 해당 링크를 방문해 새 비밀번호를 설정하세요.',
    reset_email_error:
      '이 이메일로 사용자를 찾을 수 없습니다. 대신 사용자 이름을 사용해 다시 시도하세요!',
    first_name: '이름',
    last_name: '성',
    error_firstName: '이름을 입력하세요',
    error_sharebot_organization: '조직명을 입력하세요',
    error_lastName: '성을 입력하세요',
    private_conference: '비공개 컨퍼런스',
    public_conference: '공개 컨퍼런스',
    discussion_room: '토론방',
    training_no_courses: '현재 등록된 과정이 없습니다.',
    training_no_events: '현재 등록된 이벤트가 없습니다.',
    allow_sharing_trainer_info: '마켓플레이스에서 이메일 주소 공유 허용',
    error_username_space: '사용자 이름에 공백을 포함할 수 없습니다.',
    error_sharebot_organization_space: '조직명에 공백을 포함할 수 없습니다.',
    edit_permission: '편집 권한',
    valid_price: '가격은 0보다 커야 합니다',
    course_price_message: `*과정은 조직이 구매한 사용자 수에만 공개되며 마켓플레이스에서 재판매할 수 없습니다.`,
    valid_edit_price: '수정 가격은 구매 가격보다 낮아야 합니다.',
    my_calendar: '내 캘린더',
    error_valid_firstName: '유효한 이름을 입력하세요.',
    error_valid_organization: '유효한 조직명을 입력하세요.',
    error_valid_lastName: '유효한 성을 입력하세요.',
    error_name_spaces: '이름에 공백을 포함할 수 없습니다.',
    items: '항목',
    publish_to_channel: '내 채널 컬렉션에 게시',
    create_a_channel: '내 채널 생성',
    create_a_trivia: '트리비아 게임',
    create_a_new_channel: '새 채널 생성',
    add_videos: '비디오 추가',
    save_and_continue: '저장 및 계속',
    channel: '채널',
    channels: '채널',
    view_channel: '채널 보기',
    edit_channel: '채널 편집',
    delete_channel: '채널 삭제',
    my_video_channels: '내 비디오 채널',
    training_no_channel: '현재 등록된 채널이 없습니다.',
    monthly_price_required: '월간 가격이 필요합니다',
    yearly_price_required: '연간 가격이 필요합니다',
    one_time_price_required: '일회성 가격이 필요합니다',
    marketplace_quantity: 'USD',
    report_webinar: '웨비나',
    report_coaching: '코칭',
    report_channel: '채널',
    report_public_conference: '공개 컨퍼런스',
    report_maze: '미로',
    channel: '채널',
    edit_price: '가격 수정 ($)',
    quantity: '수량',
    payment_type: '결제 유형',
    total_amount: '총 금액 ($)',
    net_amount: '순 금액 ($)',
    edit_option: '옵션 수정',
    marketplace_price: '가격 ($)',
    market_name: '이름',
    duration_min: '기간 (분)',
    users_total: '사용자 수 (총계)',
    sales_total: '총 매출 (USD)',
    search_coaching: '코칭 검색',
    search_channel: '채널 검색',
    search_webinar: '웨비나 검색',
    search_maze: '미로 검색',
    search_public_conference: '공개 컨퍼런스 검색',
    buyer_type: '구매자 유형',
    quanity: '수량',
    channel_unit_amount: '순 금액 ($)',
    channel_updated_at: '업데이트 날짜',
    month_price: '가격 (월)',
    year_price: '가격 (년)',
    one_time_price: '가격 (일회성)',
    sharebot_organization: '새 조직명 추가',
    share_sphere: '셰어스피어',
    ai_course_title: '강의 제목',
    ai_input_course_title: '강의 제목을 입력해 주세요!',
    learning_objective_label: '학습 목표',
    learning_objective_message: '학습 목표를 입력해 주세요!',
    standard_question: '학습자가 따라야 할 표준이 있나요?',
    standard_details_label: '표준 세부사항',
    standard_details_message: '표준 세부사항을 입력해 주세요!',
    estimated_duration_label: '예상 강의 시간 (분)',
    estimated_duration_message: '예상 시간을 입력해 주세요!',
    min_duration_message: '최소 시간은 5분입니다.',
    ai_mins: '25분',
    industry_specific_question: '특정 산업 분야인가요?',
    industry_label: '산업 분야 지정',
    industry_message: '산업 분야를 입력해 주세요!',
    ai_course_creation: 'AI 강의 생성',
    course_generated: 'Sharelook으로 생성된 강의',
    ai: 'AI',
    ai_you: '귀하',
    ai_prompt_ready:
      '프롬프트가 준비되었습니다. 이제 목차를 생성할 준비가 되었습니다.',
    ai_unable_respond:
      '죄송합니다! AI가 귀하의 프롬프트에 응답할 수 없습니다. 다시 시도해 주세요.',
    ai_hide_toc: '목차 숨기기',
    ai_preview_toc: '목차 미리보기',
    ai_generate_toc_now: '지금 목차 생성',
    ai_creation_course_title: '강의 제목:',
    ai_creation_industry_specific: '특정 산업 분야인가요:',
    ai_creation_industry: '산업 분야:',
    ai_creation_standard_needed: '학습자가 따라야 할 표준이 있나요?:',
    ai_creation_standard_details: '표준 세부사항:',
    ai_creation_estimated_duration: '예상 강의 시간 (분):',
    minutes: '분',
    ai_creation_learning_objective: '학습 목표:',
    setup_again: '다시 설정',
    ai_creation_confirm_title: '정말로 양식을 다시 설정하시겠습니까?',
    ai_creation_confirm_content: '채팅 및 생성한 모든 콘텐츠가 재설정됩니다.',
    ai_toc: '목차',
    ai_note_topic:
      '참고: 강의 내 주제를 드래그 앤 드롭으로 순서를 변경할 수 있습니다.',
    ai_add_topic: '+ 주제 추가',
    add_topic: '주제 추가',
    add_lesson: '강의 추가',
    add_new_lesson: '새 강의 추가',
    ai_add_lesson: '+ 강의 추가',
    attention: '주의',
    before_varifying: '확인하기 전',
    ai_save_later: '나중에 저장',
    ai_download_word_doc: 'Word 문서로 다운로드',
    ai_download_course_word_doc: '강의를 Word 문서로 다운로드',
    ai_create_course_button: '강의 만들기',
    ai_generate_course_content: '강의 콘텐츠 생성',
    ai_out_of: '중',
    ai_subtopic_failed_content:
      '하위 주제의 콘텐츠 생성에 실패했습니다. "강의 콘텐츠 생성"을 다시 클릭하여 해당 하위 주제의 콘텐츠만 생성하세요.',
    ai_edit_topic: '주제 편집',
    ai_edit_lesson_title: '강의 제목 편집',
    ai_save_topic: '주제 저장',
    ai_save: '저장',
    ai_save_lesson_title: '강의 제목 저장',
    ai_add_new_topic: '새 주제 추가',
    ai_download_ref: '참조와 함께 다운로드',
    ai_download_ref_content: '참조와 함께 강의를 Word 문서로 다운로드합니다.',
    ai_download_without_ref: '참조 없이 다운로드',
    ai_download_two_word: '두 개의 Word 문서가 다운로드됩니다:',
    ai_download_two_word_content_one: '- 참조 없이 주요 콘텐츠만 포함된 문서',
    ai_download_two_word_content_two:
      '그리고 내용 없이 참조 목록만 포함된 문서.',
    ai_manage_content: '콘텐츠 관리',
    ai_add_content_from_internet: '+인터넷에서 콘텐츠 추가',
    ai_confirm_start: '시작 확인',
    ai_Verify: '확인',
    ai_undo_warning:
      '이 과정은 시간이 걸릴 수 있습니다. 생성이 완료될 때까지 이 창을 닫지 마세요. 이 작업은 되돌릴 수 없습니다.',
    ai_verified_content:
      '콘텐츠를 확인했습니다. 확인 후에는 현재 콘텐츠로 AI 어시스턴트와 채팅으로 돌아갈 수 없습니다.',
    ai_want_proceed: '정말로 진행하시겠습니까?',
    upload_simulation: '시뮬레이션 업로드',
    name_simulation: '시뮬레이션 이름',
    selected_simulation_files: '선택된 시뮬레이션 파일',
    score_between_one_hundred: '점수는 1에서 100 사이여야 합니다.',
    are_sure_simulation: '정말로 이 시뮬레이션 파일을 삭제하시겠습니까?',
    required_simulation: '점수가 필요합니다',
    required_section_file: '섹션 파일이 필요합니다',
    simulation: '시뮬레이션',
    simulation_quiz_games: '게임에 퀴즈를 추가해야 합니다',
    simulation_alert_des:
      '모든 질문의 답변 유형이 단일 또는 다중 선택인 경우에만 게임을 추가할 수 있습니다.',
    alert_info: '정보',
    ai_number_quiz: '퀴즈 개수',
    ai_point: '점',
    ai_points: '점',
    val_required: '필수',
    games: '게임',
    add_simulation: '시뮬레이션 추가',
    text_tiewer: '텍스트 뷰어',
    back_to_account: '계정으로 돌아가기',
    delete_account: '계정 삭제',
    delete_account_title: '계정 삭제 ???',
    delete_account_subtitle: '여기서 계정을 삭제할 수 있습니다.',
    delete_account_cannot_undo:
      '계정을 삭제하려고 합니다. 이 작업은 되돌릴 수 없습니다.',
    account_org_profile:
      '생성한 모든 강의, 조직 프로필 및 모든 설정도 잃게 됩니다.',
    deleting_account_database:
      '계정을 삭제하면 데이터베이스에서 모든 데이터가 제거됩니다.',
    account_confirm_delete: '정말로 계정을 삭제하시겠습니까?',
    action_cannot_be_undone: '이 작업은 되돌릴 수 없습니다.',
    account_delete_message_success: '계정이 성공적으로 삭제되었습니다.',
    message_edit: '편집',
    message_delete: '삭제',
    message_reply: '답장',
    attached_file: '첨부 파일',
    attach_file: '파일 첨부',
    attach_des: '최대 파일 크기 25MB',
    view: '보기',
    go_to_marketplace: '마켓플레이스로 이동',
    learning_center: '학습 센터',
    knowledge_center: '지식 센터',
    sharebot: 'ShareBot',
    sharebot_help_message: '오늘 어떻게 도와드릴까요?',
    my_organization: '내 조직',
    world_knowledge: '세계 지식',
    welcome_to_sharelook: 'Sharelook에 오신 것을 환영합니다!',
    sharelook_you_want_go: '오늘 어디로 가고 싶으신가요?',
    shareLook_learning_management_system:
      'ShareLook 학습 관리 시스템에 액세스하여 조직의 라이브 이벤트 및 강의와 같은 학습 리소스를 만들거나 액세스하세요.',
    shareLook_powerful_ai_system:
      'PDF 문서를 업로드하고 몇 초 안에 유용한 통찰력을 얻을 수 있는 ShareLook의 강력한 AI 기반 시스템에 액세스하세요. 조직에 업로드된 리소스를 기반으로 빠른 답변을 얻거나 세계 지식 섹션에서 일반 AI 시스템으로부터 답변을 얻으세요.',
    edit_now: '지금 편집',
    sharelook_log_out: 'Sharelook에서 로그아웃되었습니다. 로그인해 주세요!',
    sorry_error: '죄송합니다! 오류가 발생했습니다.',
    login: '로그인',
    refresh_page: '페이지 새로고침',
    just_a_moment: '잠시만요',
    enter_lname_fname: '계속하려면 이름과 성을 입력해 주세요.',
    procced_to_sharelook: 'Sharelook으로 진행',
    option_one: '옵션 1',
    option_two: '옵션 2',
    selected_image: '선택된 이미지:',
    add_text: '텍스트 추가',
    linkdin_is_required: 'LinkedIn이 필요합니다.',
    bio_is_required: '자기소개가 필요합니다.',
    save_user_information: '사용자 정보 저장',
    select_all: '모두 선택',
    enable_ai: 'AI 활성화',
    load_more: '더 보기',
    channel_id: '채널 ID.',
    send: '보내기',
    v4: '정보',
    subscription: '구독',
    reset_user_flag: '사용자 플래그 재설정',
    delete_my_accont: '내 계정 삭제',
    sharebot_sub_error:
      '구독 정보를 가져오는 중 오류가 발생했습니다. 다시 시도해 주세요!',
    sharebot_no_sub: '현재 활성 구독이 없습니다.',
    sharebot_dont_sub: '이전 구독이 없습니다.',
    sharebot_prev_sub: '이전 구독',
    sharebot_sub: 'ShareBot 구독',
    sharebot_un_sub: 'ShareBot 구독 해지',
    sharebot_no_available: '설명 없음',
    sharebot_start_date: '시작 날짜:',
    sharebot_end_date: '종료 날짜:',
    sharebot_sure: '확실합니까?',
    sharebot_do_you_want: '정말로',
    unsubscribe: '구독 해지',
    unsubscribe_what: '구독을 해지하시겠습니까?',
    subscribe: '구독',
    subscribe_what: '구독하시겠습니까?',
    subscribe_now: '지금 구독',
    confirm: '확인',
    sharebot_intel_knowledge_center: 'ShareBot 지능형 지식 센터',
    sharebot_welcome_paragraph:
      '전문가들이 정보에 액세스하고 협업하는 방식을 변화시키도록 설계된 고급 AI 챗봇인 ShareBot 지식 센터에 오신 것을 환영합니다.',
    expired: '만료됨',
    active: '활성',
    Inactive: '비활성',
    yearly_subscription: '연간 구독',
    monthly_subscription: '월간 구독',
    no_sharebot_org: 'ShareBot 조직이 없습니다',
    sharebot_start_free_trial: '무료 체험 시작',
    sub_month: '월간 구독',
    sub_year: '연간 구독',
    question_per_month: '데이터 저장소 (1TB) 및 월 1000개 질문',
    sharebot_para:
      '진행하면 조직의 즉시 삭제를 확인하는 것입니다. 이 작업으로 인해 ShareBot이 제공하는 모든 귀중한 통찰력이 손실되며 되돌릴 수 없습니다.',
    cancelled_date: '취소 날짜:',
    live_straming_para: '월간 라이브 스트리밍 한도를 변경하려면 연락해 주세요',
    sharelook_agree: '저는 Sharelook의',
    terms_condition: '이용약관',
    and: '및',
    privacy_policy: '개인정보 보호정책',
    save_for_later: '나중에 저장',
    ai: 'AI',
    no_video_yet: '아직 선택된 동영상이 없습니다!',
    are_you_sure_delete_video: '정말로 이 동영상을 삭제하시겠습니까?',
    video_des: '설명',
    video_now: '지금',
    video_playing: '재생 중:',
    video_no: '동영상 번호.',
    ai_generated_course: 'AI 생성 강의',
    create_course_on_our_own: '직접 강의 만들기',
    ai_Assisted_ourse_reation: 'AI 지원 강의 생성',
    pending: '대기 중',
    published: '게시됨',
    intro_course: '강의에 추가하시겠습니까?',
    clone_course: '복사하시겠습니까',
    browser_audio_not_support: '브라우저가 오디오 태그를 지원하지 않습니다.',
    audio_popup_content:
      '입력한 텍스트에 다양한 음성 스타일을 사용할 수 있습니다. Lorem Ipsum은 인쇄 및 조판 업계의 표준 더미 텍스트입니다. Lorem Ipsum은 1500년대부터 업계의 표준 더미 텍스트였습니다.',
    close: '닫기',
    podcast_rec: '녹음',
    create_podcast: '팟캐스트 만들기',
    add_admin: '관리자 추가',
    delete_all: '모두 삭제',
    ai_podcast_audio: 'AI 팟캐스트 오디오',
    language: '언어',
    podcast_download_content:
      '*편집을 위해 AI 오디오 파일을 다운로드하여 오디오 파일로 만드세요.',
    upload_audio: '오디오 업로드',
    browser_do_not_support_audio: '브라우저가 오디오 요소를 지원하지 않습니다.',
    upload_cover: '커버 업로드',
    upload_ai_creator: 'AI 크리에이터',
    required_cover_image: '커버 이미지가 필요합니다!',
    room_required_name: '팟캐스트 이름이 필요합니다!',
    add_guest_list: '게스트 목록을 추가해 주세요!',
    podcast_add_participants: '참가자 추가',
    topic_required: '최소 하나의 주제가 필요합니다',
    podcast_description: '설명',
    podcast_date: '날짜',
    date: '날짜',
    podcast_time: '시간',
    podcast_to: '부터',
    podcast_all_day: '하루 종일',
    podcast_start_date_time: '시작 날짜와 시간 간격이 필요합니다!',
    podcast_id: 'ID',
    selected_user: '선택된 사용자 초대',
    see_more: '더 보기',
    see_less: '접기',
    no_review_yet: '아직 리뷰가 없습니다. 첫 번째 리뷰를 작성해 보세요.',
    request_to_speak: '사용자의 발언 요청을 수락하시겠습니까?',
    kick_user: '이 사용자를 내보내시겠습니까?',
    accept_request: '요청 수락',
    kick: '내보내기',
    started: '시작됨',
    end: '종료',
    join_now: '지금 참여',
    podcast_end: '팟캐스트가 종료되었습니다',
    connecting: '연결 중...',
    knowledge_center_know_today: '오늘 무엇을 알고 싶으신가요?',
    knowledge_center_question: '먼저 질문을 입력해 주세요',
    knowledge_center_error: '죄송합니다! 오류가 발생했습니다.',
    knowledge_center_tooltrip:
      'ShareLook의 조직 저장소에 있는 학습 리소스에서 적절한 참조와 함께 빠른 답변을 얻고, 참조된 PDF 문서를 미리 보고 다운로드할 수 있습니다.',
    my_organization: '내 조직',
    world_knowledge: '세계 지식',
    open_file: '파일 열기',
    reference: '참조',
    are_you_cancel: '정말로 취소하시겠습니까?',
    are_you_remove_media: '정말로 미디어를 제거하시겠습니까?',
    terms_agree: '다음에 동의합니다',
    ready: '준비됨',
    send_email: '이메일 보내기',
    active_users: '활성 사용자',
    sign_up_user: '가입 사용자',
    non_sign_up_user: '미가입 사용자',
    organisation: '조직',
    usage_report: '사용 보고서',
    check_email: '이메일을 확인하세요',
    delete_schedule: '일정 삭제',
    are_you_sure_delete_schedule: '정말로 이 일정을 삭제하시겠습니까?',
    add_task: '작업을 입력해 주세요!',
    coaching_available: '코칭 가능으로 표시',
    message_booking_coaching: '이 시간대는 사용자가 코칭을 위해 예약했습니다.',
    task_day: '작업 일',
    created_task_day: '이 날에 대한 작업을 생성했습니다.',
    event_day: '이벤트 일',
    has_booked_coaching: '이 날에 코칭이 예약되었습니다.',
    active_day: '활성 일',
    selectable_time_slots:
      '오른쪽의 선택 가능한 시간대가 이 날에 활성화되어 있습니다.',
    compare_last_month: '지난달과 비교',
    uploading_file: '파일 업로드 중',
    attach_file_course: '이 강의에 첨부되었습니다.',
    fetch_request: '요청 가져오는 중',
    finilize_upload: '업로드 완료 중',
    scorm_scanned:
      '잠시만 기다려 주세요... 업로드된 SCORM zip 파일을 스캔하고 있습니다.',
    scan_status: '스캔 상태:',
    scan_completed: '스캔 완료. 파일이',
    scan_progress: '스캔 진행 중...',
    check_scorm:
      'SCORM 파일 형식을 확인하고 있습니다... 잠시만 기다려 주세요...',
    file_check_success: '파일 확인 성공',
    file_check_progress: '파일 확인 진행 중...',
    scorm_not_upload:
      '업로드된 파일이 SCORM 1.2 표준이 아닙니다. 파일을 다시 업로드해 주세요.',
    select_question: '답변 옵션 (정답 하나 선택)',
    select_answer: '답변 옵션을 선택해 주세요!',
    check_option_one: '옵션 1을 입력해 주세요!',
    check_option_two: '옵션 2를 입력해 주세요!',
    check_option_three: '옵션 3을 입력해 주세요!',
    check_option_four: '옵션 4를 입력해 주세요!',
    question_image: '질문 이미지',
    select_question_image: '질문 이미지를 선택해 주세요!',
    ans_image: '답변 이미지',
    upload_image_question: '답변 이미지 업로드',
    select_image_answer: '답변 이미지를 선택해 주세요!',
    save_question: '질문 저장',
    do_you_leave: '정말로 떠나시겠습니까?',
    loose_all_progress: '모든 진행 상황을 잃게 됩니다.',
    welcome: '환영합니다',
    team_knowledge_quest: '팀 지식 퀘스트',
    your_score: '귀하의 점수',
    start_playing: '게임 시작',
    share_sphere_complete: 'ShareSphere 완료',
    final_score: '최종 점수',
    play_next: '다음 게임',
    you_donot_access_event: '이 이벤트에 액세스할 수 없습니다.',
    ai_content_generated: '이 주제에 대한 콘텐츠가 생성되었습니다.',
    ai_popup_confirm_content: '콘텐츠 생성 확인',
    limit_transcribe_text:
      '남은 전사 시간: <0>{{ transcribe_limit }}</0>분 <1/><2/> <3>. 전사 제한을 변경하려면 </3> <4>admin@sharelook.com</4>으로 문의하세요.',
    you_donot_access_event: '이 이벤트에 접근할 수 없습니다.',
    ai_course_title_training: '리더십 교육 과정',
    ai_course_object: '디지털 시대의 리더십 탐색',
    create_ai_video: 'AI 비디오 생성',
    generate: '생성하기',
    video_generate_process:
      '비디오 생성에는 시간이 걸릴 수 있습니다. 완료되면 이메일로 알려드립니다.',
    stripe_account_connect:
      'Stripe 계정이 비활성화되어 있습니다. 계속하려면 연결하거나 활성화하세요.',
    ai_creator: 'AI 크리에이터',
    check_video_status: '비디오 생성 상태 확인 중...',
    video_on_queue: '비디오 생성이 대기 중입니다.',
    video_fail_generation:
      '죄송합니다. 비디오 생성에 실패했습니다. 다른 비디오를 시도해 주세요.',
    video_currently_generated: '이 비디오는 현재 생성 중입니다.',
    checking_status: '상태 확인 중',
    check_status: '상태 확인',
    browser_does_not_support_audio:
      '사용 중인 브라우저는 오디오 태그를 지원하지 않습니다.',
    existing_edit_scenario:
      '기존 시나리오를 수정하시겠습니까, 아니면 새 시나리오를 생성하시겠습니까? 새 시나리오를 생성하면 이전 시나리오는 삭제됩니다.',
    generate_scenario: '시나리오 생성',
    layout: '레이아웃',
    confirm_change: '변경 확인',
    generated_ai_creation_message:
      'AI 생성으로 만들어진 텍스트 요소만 유지됩니다. 다른 모든 요소는 페이지에서 제거됩니다.',
    generate_story: '스토리 생성',
    save_original_content: '원본 콘텐츠 저장:',
    story_added_specified_position:
      '레슨에서 스토리가 삽입될 위치입니다. 지정된 위치에 블록으로 추가됩니다.',
    position_of_story: '스토리 위치',
    start_the_lesson: '레슨 시작',
    end_the_lesson: '레슨 끝',
    add_story_pages: '페이지에 스토리 추가',
    browser_does_not_support:
      '사용 중인 브라우저는 오디오 요소를 지원하지 않습니다.',
    no_video_available: '사용 가능한 비디오가 없습니다.',
    no_podcast_available: '사용 가능한 팟캐스트가 없습니다.',
    no_item_baskets: '장바구니에 항목이 없습니다.',
    ai_course_object: '디지털 시대의 리더십 탐색'
  },
  v2: {
    n_data: '데이터 없음',
    change: '변경',
    remove: '제거',
    auto_background: '자동 배경',
    create_new_course_org: '조직을 위한 새 강좌 만들기.',
    create_new_course_marketplace: '마켓플레이스를 위한 새 강좌 만들기.',
    create_new_course_both: '조직과 마켓플레이스 모두를 위한 새 강좌 만들기.',
    ok: '확인',
    page_bg: '페이지 배경',
    lesson_cover: '강의 커버 이미지',
    create_skill_journey: '스킬 여정 만들기',
    Metamaze: '메타메이즈',
    events: '이벤트',
    scroms: 'SCORM',
    min_score_pass: '통과를 위한 최소 점수',
    no_scorms_available: '사용 가능한 SCORM이 없습니다.',
    no_events_available: '사용 가능한 이벤트가 없습니다.',
    no_courses_available: '사용 가능한 강좌가 없습니다.',
    no_courses_baskets: '장바구니에 강좌가 없습니다.',
    no_mazes_baskets: '장바구니에 메이즈가 없습니다.',
    no_scroms_baskets: '장바구니에 SCORM이 없습니다.',
    no_events_baskets: '장바구니에 이벤트가 없습니다.',
    sorry: '죄송합니다!',
    option_1: '옵션 1',
    option_2: '옵션 2',
    enter_number_words: '최대 단어 수를 입력하세요.',
    summarize: '요약하기',
    answer: '답변',
    hold_tight_one_minute:
      '잠시만 기다려 주세요! 준비 중입니다. 최대 1분 정도 걸릴 수 있습니다.',
    enter_question: '질문을 입력하세요.',
    enter_relevant_documents: '관련 문서 수를 입력하세요.',
    please_input_relevant_documents: '관련 문서 수를 입력해 주세요!',
    please_wait_loading_results:
      '결과를 불러오는 중입니다. 잠시만 기다려 주세요...',
    proceed_to_add_voice: '음성 추가로 진행하기',
    results: '결과',
    no_result_found_try_asking_questions:
      '결과가 없습니다. 다른 질문을 시도해 보세요.',
    eg: '예: ',
    what_make_sales_manager: '어떻게 하면 영업 관리자가 될 수 있을까요?',
    please_select_lang: '언어를 선택해 주세요!',
    search: '검색',
    please_copy_desired_content:
      '원하는 콘텐츠를 왼쪽 상자에서 오른쪽 상자로 복사해 주세요.',
    rating_req: '평점은 필수 항목입니다.',
    review_req: '리뷰는 필수 항목입니다.',
    rating_review_req: '평점과 리뷰를 모두 입력해 주세요.',
    how_rate_this: '이 항목을 어떻게 평가하시겠습니까?',
    amazing_above_expectations: '놀랍습니다! 기대 이상이에요!',
    certificates: '인증서',
    you_no_certificates: '현재 이용 가능한 인증서가 없습니다.',
    please_add_review: '평점과 함께 리뷰를 작성해 주세요. 감사합니다!',
    post: '게시',
    rate: '평점',
    avg_rating: '평균 평점',
    no_review_found: '리뷰가 없습니다',
    are_sure_to_disale_zoom_integration: 'Zoom 연동을 비활성화하시겠습니까?',
    badges: '배지',
    you_no_badge_available: '현재 이용 가능한 배지가 없습니다.',
    download_certificate: '인증서 다운로드',
    loading: '로딩 중...',
    no_file_attached: '첨부된 파일이 없습니다',
    you_do_not_have_any_notes: '메모가 없습니다.',
    question: '질문',
    score: '점수',
    alert_score_message: '점수를 제출한 사람이 있습니다.',
    alert_question_message: '아직 질문이 추가되지 않았습니다.',
    button_submit: '제출',
    button_allScores: '모든 점수가 제출되었습니다.',
    record_wait: '녹음이 시작됩니다. 잠시만 기다려 주세요...',
    buttonSubmit_warning: '제출하기 전에 모든 점수를 입력해 주세요.',
    upload_ar_assets: 'AR 자산 업로드',
    edit_ar_assets: 'AR 자산 편집',
    edit_maze_assets: '메타메이즈 자산 편집',
    upload_assets: '자산 업로드',
    upload_maze_assets: '메타메이즈 자산 업로드',
    trigger_title: '트리거 제목',
    model_title: '모델 제목',
    trigger_description: '트리거 설명',
    model_description: '모델 설명',
    please_type_target_description: '대상 설명을 입력하세요.',
    please_type_model_description: '모델 설명을 입력하세요.',
    trigger_image: '트리거 이미지*',
    model_image: '모델 이미지*',
    upload_trigger_image: '트리거 이미지 업로드',
    upload_model_image: '모델 이미지 업로드',
    drag_n_drop: '드래그 앤 드롭',
    file_size_should_not_exceed:
      '(이미지 파일(JPEG) 크기는 512KB를 초과할 수 없습니다)',
    zip_size_should_not_exceed: '(ZIP 파일 크기는 60MB를 초과할 수 없습니다)',
    ar_content: 'AR 콘텐츠*',
    model_content: '3D 모델*',
    upload_3d_zip: 'ZIP / 비디오 업로드',
    upload_3d_maze_zip: 'ZIP 업로드',
    audio_content: '오디오 콘텐츠',
    _mp3: '(.mp3)',
    content_attached: 'ZIP 첨부됨.',
    video_attached: '비디오 첨부됨.',
    audio_attached: '오디오 첨부됨.',
    enter_trigger_image_title: '트리거 이미지 제목을 입력하세요.',
    enter_model_title: '메타메이즈 모델 제목을 입력하세요.',
    ar_preview_image: 'AR 미리보기 이미지',
    upload_preview_image: '미리보기 이미지 업로드',
    upload_audio: '오디오 업로드',
    creating___: '생성 중...',
    updating___: '업데이트 중...',
    create: '생성',
    update: '업데이트',
    ar_assets: '3D 이미지',
    _3d_files_mp4: '(압축된 .obj, .fbx 또는 .mp4 비디오)',
    _3d_files_mp4_ar: '(압축된 .obj, .fbx)',
    maze_3d_files_mp4: '(압축된 .obj, .fbx)',
    _jpg_files: '.jpg 파일만 지원',
    persons_have_submitted_their_scores: '점수를 제출한 사용자입니다.',
    no_questions_added_till_now: '아직 질문이 추가되지 않았습니다.',
    submit: '제출',
    all_scores_submitted: '모든 점수가 제출되었습니다.',
    recording_is_starting: '녹화가 시작됩니다. 잠시만 기다려주세요...',
    please_input_scores_before_submitting:
      '제출하기 전에 모든 점수를 입력하세요.',
    end_for_all: '모두 종료',
    full_screen: '전체 화면',
    breakout_room: '브레이크아웃 룸',
    send_invitations: '초대장 보내기',
    add_participants: '참가자 추가',
    create_breakout_room: '브레이크아웃 룸 생성',
    connecting: '연결 중...',
    currently_broadcaster_unavailable: '현재 방송자가 없습니다.',
    how_many_breakout_room_to_create:
      '몇 개의 브레이크아웃 룸을 생성하시겠습니까?',
    create_upto_three_breakout_rooms: '*최대 3개의 브레이크아웃 룸 생성',
    allow: '허용',
    additional: '추가',
    attachment: '첨부파일',
    no_description_available: '설명이 없습니다.',
    people: '사람',
    waiting: '대기 중',
    hand_raising_users: '손 들기 사용자',
    invite: '초대',
    create_room: '룸 생성',
    create_live_event: '라이브 이벤트 생성',
    support_upto_fivethousand_participants: '최대 5,000명 참가자 지원',
    support_upto_ten_participants: '최대 10명 라이브 비디오 참가자 지원',
    support_upto_twohundred_participants: '최대 200명 참가자 지원',
    supprt_upto_five_participants: '최대 5명 라이브 비디오 참가자 지원',
    support_upto_twentyfive_participants: '최대 25명 라이브 비디오 참가자 지원',
    two_live_video_participants: '라이브 비디오 참가자 2명 (호스트와 참석자)',
    you_can_have_upto_five_examinees: '최대 5명의 수험자만 가능합니다.',
    you_can_have_upto_twentyfive_participants:
      '최대 25명의 참가자만 가능합니다.',
    you_can_have_upto_five_participants: '최대 5명의 참가자만 가능합니다.',
    you_can_have_upto_ten_participants: '최대 10명의 참가자만 가능합니다.',
    select_hosts_email: '호스트 이메일 선택',
    send_invite_email: '초대 이메일 보내기',
    do_not_send_invite_email: '초대 이메일 보내지 않기',
    error: '오류',
    max_twentyfive_users_allowed: '최대 25명까지 선택할 수 있습니다',
    max_five_users_allowed: '최대 5명까지 선택할 수 있습니다',
    max_ten_users_allowed: '최대 10명까지 선택할 수 있습니다',
    no_user_found: '사용자를 찾을 수 없습니다',
    transcribe_to: '전사 대상',
    integrate_zoom_to_start_meeting: 'Zoom 연동 후 회의를 시작하세요.',
    zoom_is_not_integrated: 'Zoom이 연동되어 있지 않습니다.',
    delete_poll: '투표 삭제',
    add_poll: '투표 추가',
    live_now: '실시간 방송!',
    average_rating: '평균 평점',
    review: '리뷰',
    time_spent: '소요 시간',
    total: '총합',
    mins: '분',
    no_data: '이 퀴즈에 대한 데이터가 없습니다.',
    total_score: '총 점수',
    pass_score: '합격 점수',
    point: '점수',
    wrong: '틀림',
    response: '응답',
    submitted: '제출됨',
    average: '평균',
    total_play: '총 플레이',
    view_graph: '그래프 보기',
    time_spent_mins: '소요 시간 (분)',
    play: '플레이',
    ideal_path: '이상적인 경로',
    user_incorrect_path: '사용자 틀린 경로',
    ideal_path_taken: '사용자가 선택한 이상적인 경로',
    scenario: '시나리오',
    option: '옵션',
    spend: '소비',
    average_spending_time: '평균 소요 시간',
    activity_overview: '활동 개요',
    live_event: '라이브 이벤트',
    live_assessment: '라이브 평가',
    report_download: '보고서 다운로드',
    all_workshops: '모든 워크숍',
    overview_average_activity: '평균 활동 개요',
    overview_workshop_graph: '워크숍 그래프 개요',
    mazes: '미로',
    correct_feedback: '정답 피드백',
    incorrect_feedback: '오답 피드백',
    checkin_checkout: '체크인 - 체크아웃',
    minutes: '분',
    incorrect_path: '틀린 경로',
    answer_not_available: '답변 없음',
    views: '조회수',
    item: '항목',
    questions: '질문',
    total_points: '총 점수',
    total_attempts: '총 시도 횟수',
    created_date: '생성 날짜',
    host_name: '호스트 이름',
    host_section: '호스트 섹션',
    choose_products: '제품 선택',
    add_to_basket: '장바구니에 추가',
    basket: '장바구니',
    times: '횟수',
    scorms: 'SCORMs',
    skill_journey_overview: '기술 여정 개요',
    how_to_use: '사용 방법',
    live_broadcast_description:
      '간편한 코스 빌더에 라이브 비디오를 통합했습니다',
    live_broadcast_subdescription:
      'ShareLook의 특허 받은 라이브 방송 시스템으로 참여를 유도하고, 학습을 자동화하며, 지식 공유를 극대화할 수 있습니다.',
    disclaimer: `내 기술 여정이 다음을 포함하지 않음을 보증합니다: 
  - 제3자의 권리를 침해하지 않습니다
  - 명예 훼손, 음란, 외설, 음탕, 포르노, 폭력, 학대, 모욕, 위협, 차별적 내용(별표로 가려진 내용 포함)을 포함하지 않습니다
  - 타인에 대한 개인적 공격을 포함하지 않습니다
  - 다른 참가자, 공인 또는 유명 인사의 사칭을 포함하지 않습니다
  - 개인의 동의 없이 개인 정보나 녹음을 포함하지 않으며, 세계 어느 지역의 데이터 보호 규정을 위반하지 않습니다
  - 상업적 권유나 스팸 형태를 포함하지 않습니다`,
    price: '가격',
    video_link: '비디오 링크',
    category: '카테고리',
    objectives: '목표',
    marketplace_description: '마켓플레이스 설명',

    live_discussion: '라이브 토론',
    poll: '설문조사',
    hide_grid: '그리드 숨기기',
    show_grid: '그리드 표시',
    stop_screen_share: '화면 공유 중지',
    screen_share: '화면 공유',
    mute: '음소거',
    unmute: '음소거 해제',
    raise_hand: '손들기',
    waiting__: '대기 중...',
    audio_active: '오디오 활성화'
  },
  general: {
    save: 'บันทึก',
    autosaved: 'บันทึกอัตโนมัติ',
    back_to: 'กลับไปยัง',
    by: 'โดย',
    chat: 'การพูดคุย',
    completed: 'เสร็จ',
    canceled: '취소됨',
    component: '부품',
    confirm: '확인',
    course: '코스',
    skill: '스킬 여정',
    maze: '메타미로',
    channel: '채널',
    podcast: '팟캐스트',

    date: '날짜',
    details: '상세내용',
    empty: '정보없음',
    enrolled: '등록됨',
    free: '무료',
    graph: '그래프',
    loading: '로딩중...',
    lesson: '레슨',
    lessons: '레슨',
    live_assessment: '라이브 평가',
    live_event: '라이브 이벤트',
    no: '아니오',
    of: '###의',
    or: '또는 ',
    organization: '기관',
    page: '페이지',
    pages: '페이지들',
    personal: '개인적',
    poll: '투표',
    rating: '평가',
    reset: '리셋',
    signin: '로그인',
    signup: '계정생성',
    soon: '곧',
    type: '입력',
    uploading: '업로드 중...',
    yes: '네',
    something_went_wrong: '무언가 잘못 되었습니다!',
    view_all: '모두보기',
    upload_successful: '업로드 성공',
    upload_successful_message:
      '당신의 엑셀 문서가 성공적으로 업로드 되어 현재 처리 중입니다. 시간이 다소 걸릴 수 있습니다.',
    check_email_upload_successful:
      '업로드 된 사용자 목록 <1>보고서</1>를 보려면 <0>당신의 이메일을 확인</0>해 주세요.',
    is_private: '사적'
  },
  account: {
    title: '계정',
    subtitle: '당신의 설정과 계정 정보를 관리하세요.',
    saved: '계정이 성공적으로 변경되었습니다.'
  },
  assessments: {
    title: '평가들',
    subtitle: '평가 생성',
    finished: '평가가 끝났습니다',
    countdown: '라이브 평가가 ### 후에 방송될 것입니다',
    create: '평가 생성',
    list_title: '당신의 평가들',
    delete_warning: '정말로 이 아이템을 삭제하시겠습니까?',
    details_title: '평가 정보 추가',
    details_subtitle:
      '당신의 평가 이름을 만들고 시청자들에게 평가로 부터 무엇을 배울 수 있는지 알려주세요.',
    disclaimer: `제 녹화 이벤트가 다음에 해당하지 않을 것을 약속합니다: \n     \t•어떤 제 3자의 권한을 침범\n     \t•명예 훼손, 음란, 무례, 성적, 음란물, 폭력적, 모욕적, 학대적, 위협적이거나 차별적\n      인 콘텐츠, 심지어 별표로 위장한 경우와 같은 모든 불법적 활동을 포함\n     \t•다른 사람들에 대한 사적 공격들을 포함\n     \t•다른 참가자들, 공적 인물들 또는 연예인들 거짓 행세\n     \t•해당 개인의 동의 없이 그 개인 또는 그 개인의 사적정보의 녹화물을 포함하고 전 세계 모두의 정보 보호 규제법을 어기지 않음\n     \t•어떤 상업적 시도 또는 어떤 형태의 “스팸”을 포함`,
    assessment_details: '평가 정보',
    assessment_settings: '평가 설정'
  },
  buildersettings: {
    title: '출판 설정',
    subtitle: '이벤트에 누가 열람이 가능하고 참가가 가능한지 설정을 추가하세요.'
  },
  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: '추가',
    add_page: '페이지 추가',
    add_lesson: '레슨 추가',
    add_answer: '새 정답 추가',
    add_group: '그룹 추가',
    add_organization: '기관 추가',
    add_question: '질문 추가',
    add_quiz: '퀴즈 추가',
    add_users: '사용자 추가',
    back: '뒤로',
    back_to_course: '코스 전체보기로 돌아가기',
    back_to_lesson: '레슨 전체보기로 돌아가기',
    back_to_media: '미디어 라이브러리로 돌아가기',
    back_to_details: '상세정보로 돌아가기',
    cancel: '취고',
    clear: '지우기',
    close: '닫기',
    clone: '복사',
    close_lesson: '레슨 닫기',
    clone_course: '코스 복사',
    confirm: '확인',
    create: '생성',
    download: '다운로드',
    download_mass_user_tamplate: '형식 다운로드하기',
    add_mass_users: '집단 사용자들 추가',
    upload_excel_list: '엑셀 목록 업로드',
    delete: '미디어 삭제',
    edit: '편집',
    edit_course: '코스 편집',
    enroll: '등록',
    finish: '끝내기',
    upload_image: '이미지 업로드',
    upload_image_video: '이미지 또는 비디오 업로드',
    select_media_library: '미디어 라이브러리 선택',
    make_public: '공개하기',
    make_private: '비밀로 하기',
    make_org: '기관 생성',
    media: '미디어 라이브러리',
    my_theme: '내 주제',
    next: '다음',
    next_lesson: '다음 레슨',
    next_step: '다음 단계',
    previous_step: '이전 단계',
    publish: '출판',
    publish_assessment: '당신의 평가 출판하기',
    publish_course: '당신의 코스 출판하기',
    publish_event: '당신의 이벤트 출판하기',
    reset: '리셋',
    reset_elements: '요소드르 리셋',
    save: '저장',
    creating: '생성중...',
    updating: '업데이트중...',
    saved: '저장됨',
    save_for_later: '미뤄두기',
    save_settings: '설정 저장',
    select_files: '파일 선택',
    select_theme: '주제 선택',
    start_lesson: '레슨 시작',
    update: '업데이트',
    upload: '업로드',
    upload_audio: '오디오 업로드',
    upload_photo: '프로파일 사진 업로드',
    upload_video: '비디오 업로드',
    enrolled: '등록됨',
    unenroll: '등록취소',
    from_library: '미디어 라이브러리',
    remove: '제거',
    removed: '제거됨',
    start_broadcast: '방송 시작',
    end_broadcast: '방송 종료',
    camera: '카메라',
    screen: '화면',
    screen_with_camera: '카메라 화면',
    insert: '삽입',
    inserting: '삽입'
  },
  card: {
    quick_add: '빠른 추가',
    add: '추가',
    clone: '복사',
    completed: '레슨 완료됨'
  },
  course: {
    upcoming_course: '곧 다가오는 코스',
    unPublishEvent: '출판되지 않은 이벤트',
    unPublishAssessment: '출판되지 않은 평가',
    pastCourse: '훈련 코스',
    upcoming: '다가오는 라이브 이벤트',
    pastEvent: '과가 라이브 이벤트',
    pastAssessment: '과거 라이브 평가',
    upcomingAssessment: '다가오는 라이브 평가',
    created: '생성된 날짜:',
    assignees: '지정인',
    organisations: ' {{ 기관들 }} 기관들, <2> {{ 사용자들 }} 사용자들</2>',
    event_date: '라이브 이벤트 날짜  <1> {{ 잘짜 }} </1>',
    delete_warning: '정말로 삭제하시겠습니까?',
    clonning_no_lesson: '이 코스를 복사하려면 최소 한 개의 레슨을 추가하세요',
    clone_warning: '정말로 복사하시겠습니까',
    clone_success: '현재 복사 중입니다',
    disclaimer:
      '제 녹화 이벤트가 다음에 해당하지 않을 것을 약속합니다: \n     \t•어떤 제 3자의 권한을 침범\n     \t•명예 훼손, 음란, 무례, 성적, 음란물, 폭력적, 모욕적, 학대적, 위협적이거나 차별적\n      인 콘텐츠, 심지어 별표로 위장한 경우와 같은 모든 불법적 활동을 포함\n     \t•다른 사람들에 대한 사적 공격들을 포함\n     \t•다른 참가자들, 공적 인물들 또는 연예인들 거짓 행세\n     \t•해당 개인의 동의 없이 그 개인 또는 그 개인의 사적정보의 녹화물을 포함하고 전 세계 모두의 정보 보호 규제법을 어기지 않음\n     \t•어떤 상업적 시도 또는 어떤 형태의 “스팸”을 포함'
  },
  coursecreate: {
    dropzone_text: '미디어 삽입',
    sidebar_text: '<1/> 당신의 <3/> 레슨들을 위한 주제를 선택하세요',
    delete_warning: '정말로 이 레슨을 삭제하시겠습니까?'
  },
  coursepage: {
    quizview_loading: '정답 확인 중... 기다려주세요',
    quizview_answer: '당신의 답'
  },
  coursequiz: {
    title: '모든 레슨 내 퀴즈들'
  },
  dashboard: {
    tooltip_title: '다시 이 비디오를 보여주지 마세요',
    page_title: '당신 코스들의 통계',
    page_subtitle: '당신이 생성한 코스들의 상태',
    profile_add_info:
      '프로파일을 완성하려면 당신의 <1>{{uncompletedText}}</1>를 추가하세요',
    profile_build:
      '<1>여기</1>에 당신의 프로파일을 만드세요, 당신의 흥미와 기술들을 알려주세요.',
    profile_title: '프로파일 강세',
    more_details: '더 자세한 정보'
  },
  errors: {
    answer: '답을 입력해 주세요',
    answer_correct: '옳은 답을 선택해 주세요',
    code: '당신의 코드를 입력하세요',
    criterion: '기준을 입력하세요',
    duration: '기간이 필요합니다',
    element: '요소를 입력하세요',
    email: '이메일을 입력하세요',
    email_invalid: '유효한 이메일이 아닙니다',
    feedback_correct: '올바른 피드백을 입력하세요',
    feedback_incorrect: '올바르지 않은 피드백을 입력하세요',
    host: '이벤트 호스트를 입력하세요',
    host_assessment: '평가 호스트를 입력하세요',
    image: '이미지를 업로드하세요',
    location: '당신의 위치를 업로드하세요',
    live_location: '방송 위치를 선택하세요',
    limit: '라이브 스트리밍 분을 입력하세요',
    min_3char: '최소 3 문자',
    number: '양수를 입력하세요',
    host_email_require: '호스트 이메일이 필요합니다',
    attendee_email_require: '참가자들의 이메일이 필요합니다',
    name: '당신의 이름을 입력하세요',
    not_found_course: '코스가 발견되지 않았습니다',
    not_found_event: '이벤트가 발견되지 않았습니다',
    not_found_assessment: '평가가 발견되지 않았습니다',
    password: '당신의 비밀번호를 입력하세요',
    password_digit: '최소 한 개의 숫자',
    password_short: '비밀번호가 짧습니다, 최소 10개 문자가 필요합니다',
    password_special: '최소 한개의 특수문자',
    password_uppercase: '최소 한개의 대문자',
    password_lowercase: '최소 한개의 소문자',
    phone: '당신의 전화번호를 입력하세요',
    phone_invalid: '유효하지 않은 전화번호',
    position: '당신의 위치를 입력하세요',
    question: '질문을 입력하세요',
    start_date: '시작 날짜 & 시간이 필요합니다',
    tag: '태그를 선택하세요',
    topics: '최소 한개의 주제를 선택하세요',
    live_topics: '주제를 추가하세요',
    title: '제목을 입력하세요',
    title_assessment: '평가 제목을 입력하세요',
    title_course: '코스 제목을 입력하세요',
    title_empty: '제목을 비울 수 없습니다',
    title_event: '이벤트 제목을 입력하세요',
    title_lesson: '레슨 제목을 입력하세요',
    title_quiz: '퀴즈 이름을 입력하세요',
    username: '당신의 아이디를 입력하세요',
    upload_error: '오류 - 파일이 호환되지 않습니다!',
    upload_more_than_10:
      '한번에 최대 10개 까지의 파일을 업로드 할 수 있ㅅ브니다',
    topics_max: '최대 3개 까지의 주제를 더하세요',
    upload_excel: '올바른 파일을 업로드 했는지 확인하세요',
    title_excel: '형식 업로드 오류:',
    file_size_exceed: '파일 사이즈 초과',
    subtitle_excel: '제공된 형식을 사용하고 열들에 작성했는지 확인하세요',
    select_broadcast_option: '이 이벤트 방송을 위한 옵션을 선택하세요',
    multi_hosts_number_error:
      '방송자들의 수는 이 이벤트를 위해 지정된 수를 초과할 수 없습니다. ',
    conference_people_number_error:
      '참가자들의 수는 이 이벤트를 위해 지정된 수를 초과할 수 없습니다. ',
    select_max_host: '이 이벤트를 위해 최소 한명의 방송자를 선택하세요',
    select_max_conference: '이 이벤트를 위해 최소 한명의 참가자를 선택하세요',
    stream_stop_error: '갑자기 스트리밍이 중지되었습니다!',
    unsecure_context:
      '치명적 오류: 안전하지 않은 환경으로 브라우져가 카메라와 마이크에 접속할 수 없습니다. SSL을 설치하고 https로 접속하세요',
    ws_not_supported: '치명적 오류: 웹소켓이 이 브라우져에서 지원되지 않습니다'
  },
  events: {
    title: '라이브 이벤트 상세정보 추가',
    change_host: '호스트 변경',
    finished: '이벤트가 끝났습니다',
    countdown: '### 후에 라이브 이벤트가 방송됩니다',
    subtitle:
      '당신 라이브 이벤트 이름을 정하고 관중들에게 이 이벤트로 부터 무엇을 배울 수 있는지 알려주세요.',
    poll_disabled: '이 이벤트에서는 투표가 불가능합니다',
    disclaimer:
      '제 녹화 이벤트가 다음에 해당하지 않을 것을 약속합니다: \n     \t•어떤 제 3자의 권한을 침범\n     \t•명예 훼손, 음란, 무례, 성적, 음란물, 폭력적, 모욕적, 학대적, 위협적이거나 차별적\n      인 콘텐츠, 심지어 별표로 위장한 경우와 같은 모든 불법적 활동을 포함\n     \t•다른 사람들에 대한 사적 공격들을 포함\n     \t•다른 참가자들, 공적 인물들 또는 연예인들 거짓 행세\n     \t•해당 개인의 동의 없이 그 개인 또는 그 개인의 사적정보의 녹화물을 포함하고 전 세계 모두의 정보 보호 규제법을 어기지 않음\n     \t•어떤 상업적 시도 또는 어떤 형태의 “스팸”을 포함',
    prompt_message:
      '이 페이지를 떠나면 이벤트가 종료됩니다. 정말로 이 페이지를 떠나시겠습니까?',
    duration_exceed_message:
      '당ㅇ신의 방송 시간이 초과되면 앱이 방송을 종료할 것입니다.',
    before_schedule_message:
      '계획된 이벤트 시간 전에 방송을 시작하게 됩니다. 방송을 중지하면 이벤트가 종료됩니다.',
    browser_unsupportive_message:
      '당신의 브라우져는 화면 공유를 지원하지 않습니다. 이 링크로 지원되는 브라우져들을 볼 수 있습니다',
    cancel_switch_host_message:
      '호스트가 불가능합니다. 이 이벤트는 당신 쪽에서 계속됩니다.',
    coaching_prompt_message:
      '이벤트 종료 시 까지 이 페이지를 떠날 수 없습니다.',
    event_modal_warn: '이 이벤트를 떠나시겠습니까?',
    confirm_message: 'OK를 클릭하면 이벤트가 종료됩니다.',
    screen_share_denied: '화면 공유를 거절하였습니다',
    media_not_found:
      '카메라와 마이크가 없거나 당신 기기에서 접속이 허용되지 않았습니다',
    media_not_access:
      '다른 어떤 프로세스가 카메라와 마이크를 사용하고 있으며 기기의 접속을 막고있습니다',
    constraint_error:
      '당신의 비디오와 오디오 조건을 충족하는 기기를 발견하지 못했습니다. 비디오 및 오디오 조건을 바꾸세요.',
    media_access_denied: '카메라와 마이크에 접속하도록 허용받지 않았습니다'
  },
  filters: {
    days7: '지난 7일',
    days15: '지난 15일',
    days30: '지난 30일',
    days365: '지난 365일',
    date: '생성된 날짜',
    relevance: '관련',
    popularity: '인기',
    name: '이름',
    group: '그룹',
    Newest_to_Oldest: '최신순',
    Oldest_to_Newest: '가장 오래된 순',
    A_Z: 'ㄱ 에서 ㅎ',
    Z_A: 'ㅎ 에서 ㄱ'
  },
  helpers: {
    password:
      '당신의 계정을 안전하게 지키기 위해 최소 한개의 소문자와 한개의 숫자가 요구됩니다. 또한 최소 10개 글자가 팔요합니다.',
    phone: '전화 국가 코드를 포함해 주세요, 예를 들어: +65',
    username:
      '당신의 아이디는 공적 정보로 다뤄지며 필요시 다른 사용자들과 공유됩니다. 그러므로, 당신의 사적 정보를 당신의 아이디에 사용하지 않을 것을 권고드립니다.',
    public_description_normal:
      '당신의 <0><0/></0>는 저장되었으며 비밀로 초기화됩니다. 이는 당신만이 이 컨텐츠를 볼 수 있다는 의미입니다. 이 컨텐츠를 공개하려면 아래 옵션 중 하나를 선택할 수 있습니다. 당신의 코스를 대중에게 공개한다는 것은 이 플랫폼 모든 사용자들이 그 코스를 사용할 수 있다는 의미입니다.  이 특정 사용자 옵션을 통해 Sharelook 계정에 연결된 원하는 사용자들의 이메일 주소를 사용해 특정 사용자들과 당신의 코스를 공유할 수 있습니다. ',
    public_description_admin:
      '이 <0><0/></0>는 저장되었으며 비밀로 초기화됩니다. 이는 당신(그리고 이 컨텐츠 창조자)만이 이 컨텐츠를 볼 수 있다는 의미입니다. 이 컨텐츠를 공개하려면 아래 옵션 중 하나를 선택할 수 있습니다. 당신의 코스를 대중에게 공개한다는 것은 이 플랫폼 모든 사용자들이 그 코스를 사용할 수 있다는 의미입니다 – 이는 당신 기관 외 사람들도 포함합니다. 그 코스를 기관에게 공개한다는 것은 그 기관 내 모든 사용자들이 그 코스를 볼 수 있다는 뜻입니다. 또한 당신은 그 코스를 1개 이상의 그룹들에게 공개할 수 있으며 이는 그 그룹들 내 사용자들 만이 그 코스를 볼 수 있다는 것을 의미합니다. 마지막으로, 원하는 사용자들의 Sharelook 계정 이메일 주소를 사용하여 당신 기관 내 그리고 기관 외 특정 사용자들에게 공개할 수도 있습니다.'
  },
  labels: {
    add: '추가',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: '정답 종류',
    answers: '정답들',
    back_to_quiz: '퀴즈 목록으로 돌아가기',
    back_to_question: '질문 목록으로 돌아가기',
    chat: '채팅',
    chat_available: '이 이벤트에서는 채팅이 불가능합니다',
    chat_report: '채팅 리포트',
    choice_single: '일형식',
    choice_multiple: '다형식',
    choice_free: '"Free" 선택',
    choice_sorting: '"Sorting" 선택',
    choice_matrix: '"Matrix Sorting" 선택',
    clone_lesson_permission: '허가 복사',
    code: '코드',
    correct: '정답',
    created: '생성 날짜',
    clone_modal: '코스 복사',
    cloning_course: '코스 복사중...',
    cloning: '복사중...',
    cloning_course_desc:
      '이 과정은 어느정도 시간이 걸릴 수 있습니다. 기다려주세요',
    cloning_success: '코스 "<0/>" 가 성공적으로 복사되었습니다!',
    description: '설명',
    disclaimer: '부인성명',
    drop_file: '여기에 파일을 놓으세요...',
    duration: '기간',
    edit: '편집',
    email: '이메일',
    event: '이벤트',
    event_all: '그의 모든 이벤트들',
    event_date: '라이브 이벤트 로컬 날짜/시간',
    event_this: '이 이벤트',
    expire: '###에 만료',
    expiry_date: '만료 날짜',
    forgot: '패스워드를 잊어버렸나요?',
    group: '그룹',
    groups_list: '그룹들 목록',
    host: '호스트',
    id_annotation: '주석 아이디',
    id_quiz: '퀴즈 아이디',
    incorrect: '옳지 않음',
    interests: '흥미들',
    invited: '초대됨',
    live_chat: '라이브 토론',
    live_stream_limit: '라이브 스트리밍 분',
    contact_text: '월별 라이브 스트리밍 제한을 바꾸려면 ###에 연락해 주세요',
    contact_admin:
      '<0>당신의 월별 라이브스트리밍 제한을 바꾸려면 </0> <1>admin@sharelook.com</1>에 연락해 주세요',
    limit_stream_text:
      '남은 라이브스트리밍 분: <0>{{ limit }}</0> 분 <1/><2/> <3>당신의 월별 라이브스트리밍 제한을 바꾸려면 </3> <4>admin@sharelook.com</4>에 연락해주세요',
    location: '위치',
    lessons: '레슨',
    location_broadcast: '호스트 서버 위치',
    location_broadcast_subtitle:
      '오디오비주얼 지연을 줄이기 위해 방송 호스트 위치에 가장 가까운 위치를 추가하세요',
    media_manager: '미디어 매니져',
    minutes: '분',
    name: '이름',
    online_quiz: '온라인 퀴즈',
    organiser: '저자',
    organization: '기관',
    overall_emotion: '전체적 경험:',
    organizations_list: '기관 목록',
    password: '패스워드',
    participants: '참가자들',
    picture: '사진 (16:9)',
    phone: '전화',
    photo: '사진',
    poll: '투표',
    position: '직책',
    processing: '처리중',
    privacy_settings: '사생활보호 설정',
    question: '질문',
    quiz_create: '새 퀴즈 만들기',
    quiz_name: '퀴즈 이름',
    quiz_update: '퀴즈 업데이트',
    select_organization: '기관 선택',
    settings: '설정',
    show: '보기',
    show_graph: '그래프 결과 보기',
    signin: '로그인',
    signup: '계정생성',
    sort_by: '###로 정리하기',
    start_date: '시작 날짜',
    tags: '태그들',
    terms: '저는 이 <1>약관</1>들에 동의합니다.',
    title: '제목',
    topics: '주제들',
    topic: '주제',
    total_comments: '총 댓글들',
    username: '아이디',
    users_list: '사용자들 목록',
    users_emails: '특정 사용자 이메일을 입력해 주세요',
    description_specifiction_email:
      '다수 특정 사용자들과 공유하기 위해 줄 하나당 한개의 이메일 주소를 입력해주세요.',
    message_specific_email: '특정 사용자의 이메일을 입력해 주세요.',
    viewers: '시청자들',
    edit_course: '편집',
    edit_assessment: '편집',
    edit_event: '편집',
    delete_course: '삭제',
    delete_event: '삭제',
    delete_assessment: '삭제',
    view_course: '보기',
    view_event: '보기',
    view_assessment: '보기',
    date_event: '라이브 이벤트 날짜들',
    date_assessment: '라이브 평가 날짜',
    clone_of: '복사',
    clone_course:
      'Create a clone of this course that you can modify independently of the original, includes all lessons and pages.',
    make: '만들기',
    available_to: '모든 ShareLook 사용자가 이용가능',
    uploaded_by: '업로드: ',
    course: '코스',
    assessment: '평가',
    user_not_exist: '사용자가 존제하지 않습니다, 초대를 보내시겠습니까?',
    check_user: '알림',
    user_not_exist_in_org:
      '이 기관에 사용자가 존제하지 않습니다, 초대를 보내시겠습니까?',
    title_modal_stream: '기관 라이브스트리밍 제한 변경',
    des_warning_stream: '변경을 하게 됩니다',
    monthly_stream: '월별 라이브스트리밍 제한:',
    min_per_month: '분/월',
    broadcast_label: '하고 싶은 것:',
    hosts_emails: '특정 호스트의 이메일 입력',
    attendee_emails: '특정 참가자의 이메일 입력',
    description_host_specifiction_email: '한 줄당 한개의 이메일을 입력하세요',
    presenter_label: '프레젠터',
    presenter_label_conference: '사람 수',
    event_privacy: '컨퍼런스 모드'
  },
  broadcastOptions: {
    stream_from_phone: '폰으로 라이브 스트리밍하기',
    other_webrtc: 'PC에서 웨비나 하기',
    multihost: '내 PC에서 웨비나 멀티캐스트',
    peer2peer: '코칭 세션',
    conference: '라이브 컨퍼런스'
  },
  lessoncreate: {
    title: '레슨 상세내용 더하기',
    subtitle:
      '레슨 이름을 정하고 시청자들이 이 레슨에서 무엇을 배울 수 있는지 알려주세요',
    input_label_title: '레슨 제목',
    input_label_topics: '레슨 주제',
    input_label_description: '레슨 설명',
    delete_warning: '정말로 이 페이지를 삭제하시겠습니까?'
  },
  lessonoverview: {
    title: '레슨 추가',
    subtitle: '이미 존재하는 레슨 추가 또는 새 레슨 생성',
    new_lesson: '새 레슨 생성',
    new_lesson_sub: '처음부터 새로운 레슨 만들기!',
    existing_lesson: '이미 존재하는 레슨 선택하기',
    existing_lesson_sub:
      '이미 존재하는 레슨으로의 링크, 이 레슨에 적용된 변경내용들은 다른 코스들에도 적용됩니다',
    clone_lesson: '이미 존재하는 레슨 복제하기',
    clone_lesson_sub:
      '이 코스 레슨의 특수 카피를 만듭니다, 이 레슨에 적용된 변경내용들은 본 레슨에는 적용되지 않습니다.',
    clone_lesson_modal_sub:
      '코스에 추가하고자 하는 레슨 아래의 복사 버튼을 클릭해주세요'
  },
  management: {
    groups_title: '그룹들 관리',
    delete_warning: '확실합니까?',
    organizations_title: '내 기관들',
    organizations_subtitle: '목록에 기관 추가하기',
    users_title: '사용자 관리',
    users_position: '시니어 어카운트 매니져',
    user_not_found: '사용자 발견 안됨',
    select_org: '사용자들 관리를 위해 기관을 발견 및 선택해주세요'
  },
  audio: {
    modal_title: '오디오 입력',
    list_view: '목록 뷰',
    create_audio_modal_title: '오디오 생성',
    edit_audio_modal_title: '오디오 편집',
    public_audio_not_found: '오디오 발견 안됨',
    private_audio_not_found: '아직 오디오를 업로드하지 않았습니다',
    are_you_sure_to_delete: '정말로 삭제하시겠습니까?',
    type_something: '입력해보세요',
    select_voice: '선택',
    file_name: '파일 이름',
    description: '설명',
    topic: '주제',
    key_words_tag: '키워드 태그',
    mp3_audio: 'MP3 오디오',
    created: '생성됨',
    duration: '기간',
    close: '닫기'
  },
  image: {
    modal_title: '이미지 삽입',
    image: '이미지',
    pixel: '픽셀',
    dimension: '수치',
    public_image_not_found: '이미지 없음',
    private_image_not_found: '아직 아무 이미지도 업로드하지 않았습니다'
  },
  annotation: {
    modal_title: '주석'
  },
  text: {
    modal_title: '텍스트 편집기'
  },
  video: {
    modal_title: '비디오 삽입',
    image: '비디오',
    mp4_video: 'MP4 비디오',
    public_video_not_found: '비디오 없음',
    private_video_not_found: '아직 비디오를 업로드하지 않았습니다'
  },
  media: {
    title: '미디어 라이브러리',
    subtitle: '당신 파일 라이브러리',
    modal_title: '미디어 업로드',
    delete_warning: '삭제 확인',
    delete_message: '삭제된 미디어는 사용된 페이지에 계속해서 나타날 것입니다',
    dropzone_text: '또는 드래그 드랍',
    delete_success: '미디어가 성공적으로 삭제 되었습니다',
    upload_file: '파일 업로드',
    drag_drop: '또는 드래그 드랍',
    import_file: '컴퓨터에서 파일(들) 불러오기',
    no_media: '아직 미디어를 업로드 하지 않았습니다',
    media_type: '미디어 종류',
    video: '비디오',
    image: '이미지',
    audio: '오디오',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: '미디어가 없습니다',
    of: '###의',
    disclaimer:
      '제 녹화 이벤트가 다음에 해당하지 않을 것을 약속합니다: \n     \t•어떤 제 3자의 권한을 침범\n     \t•명예 훼손, 음란, 무례, 성적, 음란물, 폭력적, 모욕적, 학대적, 위협적이거나 차별적\n      인 콘텐츠, 심지어 별표로 위장한 경우와 같은 모든 불법적 활동을 포함\n     \t•다른 사람들에 대한 사적 공격들을 포함\n     \t•다른 참가자들, 공적 인물들 또는 연예인들 거짓 행세\n     \t•해당 개인의 동의 없이 그 개인 또는 그 개인의 사적정보의 녹화물을 포함하고 전 세계 모두의 정보 보호 규제법을 어기지 않음\n     \t•어떤 상업적 시도 또는 어떤 형태의 “스팸”을 포함',
    my_media: '내 미디어',
    public_library: '공공 라이브러리',
    organization_library: '기관 라이브러리',
    upload_from_computer: '컴퓨터에서 업로드',
    create: '생성',
    male: '남성',
    female: '여성',
    processing_audio: '오디오 처리 중',
    create_annotation: '각주 추가 중',
    popup_over_lesson_text: '클릭 후 각주가 레슨 페이지 위에 나타날 것입니다',
    edit_detail: '자세정보 편집',
    delete: '삭제',
    go_create_audio: '오디어 생성',
    show_more_details: '더 많은 정보 보기',
    show_less_details: '정보 숨기기',
    drop_files: '업로드 경로와 파일들을 드랍하세요',
    or: '또는',
    import_files: '컴퓨터에서 파일들 가져오기'
  },
  navigation: {
    account: '계정',
    assessments: '평가',
    dashboard: '대쉬보드',
    groups: '그룹 관리',
    logout: '로그아웃',
    organisations: '기관',
    organizations_users: '기관 & 사용자들',
    reports: '리포트',
    schedule: '스케쥴',
    training: '트레이닝',
    users: '사용자들',
    workshop: '내 워크샵',
    nowLive: '방송'
  },
  onboarding: {
    step1_title: '단계 1 : 자기소개를 조금 해 주세요',
    step1_subtitle:
      '이름이 무엇인가요? 어디 나라에 사시나요? 직책이 무엇인가요?`',
    step2_title: '단계 2 : 향상할 수 있는 기술을 몇가지 선택해주세요',
    step2_subtitle:
      '다음으로, 더 잘 이해하고자 하는 것을 알려주세요. 아직 안 배운 것이 있나요? 새 분야의 공부? 당신이 사랑하는 이들이 하는 일들?'
  },
  pagebuilder: {
    title: '레슨 생성',
    subtitle:
      '시청자들이 배울 수 있는 컨텐츠를 만들 시간입니다, 사진, 비디오, 인포그래픽들을 사용할 수 있습니다',
    select_layout: '페이지 레이아웃 선택',
    template1: '빈',
    template2: '제목 & 부제목',
    template3: '제목 & 텍스트',
    template4: '제목, 미디오 & 텍스트',
    template5: '제목 & 미디어',
    template6: '제목 & 퀴즈'
  },
  pageconstructor: {
    title: '레슨 생성 및 복사',
    subtitle:
      '시청자들이 배울 수 있는 컨텐츠를 만들 시간입니다, 사진, 비디오, 인포그래픽들을 사용할 수 있습니다'
  },
  passwordreset: {
    success_coded:
      '당신이 제공한 이메일 주소로 인증 코드를 보냈습니다, 아래 필드에 붙여넣기 하여 새 패스워드를 설정하세요.',
    success_changed:
      '성공적으로 새 패스워드를 설정했습니다, 이제 로그인할 수 있습니다.'
  },
  placeholders: {
    search: '검색',
    answer: '정답',
    chat: '말해보세요...',
    code: '코드',
    criterion: '기준',
    date_event: '날짜 & 시간 선택',
    date_start: '시작 날짜',
    date_expire: '만료 날짜',
    description: '설명',
    elements: '요소 정리',
    email: '이메일',
    feedback_correct: '피드백 옮음',
    feedback_incorrect: '피드백 옳지 않음',
    host: '호스트',
    keywords: '키워드(들) 검색',
    lesson_description: '레슨 설명',
    location: '위치',
    minutes: '분',
    name: '이름',
    organiser: '저자',
    organization: '기관',
    password: '패스워드',
    phone: '전화',
    photo: '사진',
    picture: '사진',
    point: '포인트',
    position: '직책',
    question: '질문',
    quiz: '퀴즈 이름',
    search_course: '코스로 검색',
    search_media: '미디어 검색',
    search_name: '이름으로 검색',
    search_title: '제목으로 검색',
    search_training: '훈련 검색',
    settings: '설정',
    tags: '태그',
    title: '제목',
    topics: '주제들',
    username: '아이디',
    keyword: '키워드',
    max_500_characters: '최개 500 글자',
    no_description: '이 파일에 설명이 없습니다',
    no_keyword: '이 파일에 키워드가 없습니다',
    no_topics: '이 파일에 설정된 주제가 없습니다',
    feedback: '메시지',
    contact: '어떻게 도와드릴 수 있나요?'
  },
  publishsettings: {
    title: '공개 설정',
    event_subtitle:
      '누가 당신의 이벤트를 보고 참가할 수 있는지 당신의 이벤트에 설정을 추가하세요',
    assessment_subtitile:
      '당신의 평가의 이름을 정하고 시청자들이 무엇을 배울 수 있는지 알려주세요',
    course_subtitle:
      '누가 당신의 코스를 볼 수 있고 참가할 수 있는 지 당신의 코스에 설정을 추가하세요',
    disclaimer:
      '1. 등록\n사용자로서 등록/계정을 생성함으로써 당신은 저희 [사용자동의서]에 동의하고 저희 [사생활보호정책]를 읽었음을 인지합니다.\n 2. 코스 만들기\n 저희의 도구를 사용하여 코스 컨텐츠를 만듬으로써, 당신은 저희 [사용자동의서]에 동의하고 저희 [사생활보호정책]를 읽었음을 인지합니다. \n 3. 이벤트 만들기\n저희의 도구를 사용하여 이벤트 컨텐츠를 만듬으로써, 당신은 저희 [사용자동의서]에 동의하고 저희 [사생활보호정책]를 읽었음을 인지합니다. \n 4. 평가 만들기\n저희의 도구를 사용하여 평가 컨텐츠를 만듬으로써, 당신은 저희 [사용자동의서]에 동의하고 저희 [사생활보호정책]를 읽었음을 인지합니다.',
    dates_validation_error: '두 날짜 모두 채워져야 합니다',
    emails_validation_error: '이메일 목록이 유효하지 않습니다.',
    specific_email_validation_error: '한개의 이메일만 가능합니다',
    i_agree_to_these: '저는 이것에 동의합니다',
    terms_and_conditions: '약관',
    PublicDescription:
      '무료 독립 사용자들: (개인 및 공공 옵션들) 당신의 [코스|이벤트|평가]가 저장되었고 비밀로 초기화됩니다. 이는 당신만이 이 컨텐츠를 볼 수 있다는 것을 의미합니다. 이 컨텐츠 공개를 위해서는 아래에서 선택이 가능합니다. 이는 코스가 이 플랫폼의 모든 사용자들에게 공개된다는 의미입니다.',
    OrganisationsDescription:
      'Org 사용자들:  ""Finish"" 대신 ""Publish""을 사용하고, 출판 옵션들 없이, 다른 사용자들과 같이 출판 페이지로 가져옴) 당신의 [코스|이벤트|평가]가 저장되었고 비밀입니다. 이는 당신과 당신 기관의 운영자들만이 열람이 가능하다는 것을 의미합니다. 사용자로서, 당신은 운영자 권한 없이 스스로 자신의 기관내에서 자신의 컨텐츠를 출판할 수 없습니다. 당신의 운영자들 중 한명에게 연락하여 당신의 컨텐츠를 기관 전체, 기관 내 특정 그룹, 또는 특정 사용자들에게 공적으로 출판하기를 요청하세요. ',
    OrganisationGroupsDescription:
      'Org 운영자들: (기관 내에서 만들어진 컨텐츠에 대해: 비밀, 공개, 기관, 그룹, 특정 사용자들): 이 [코스|이벤트|평가]는 저장되었고 비밀로 초기화되어 있습니다. 이는 당신(그리고 이 컨텐츠 창조자)만이 이 컨텐츠를 볼 수 있다는 의미입니다. 이 컨텐츠를 공개하려면 아래 옵션 중 하나를 선택할 수 있습니다. 당신의 코스를 대중에게 공개한다는 것은 이 플랫폼 모든 사용자들이 그 코스를 사용할 수 있다는 의미입니다 – 이는 당신 기관 외 사람들도 포함합니다. 그 코스를 기관에게 공개한다는 것은 그 기관 내 모든 사용자들이 그 코스를 볼 수 있다는 뜻입니다. 또한 당신은 그 코스를 1개 이상의 그룹들에게 공개할 수 있으며 이는 그 그룹들 내 사용자들 만이 그 코스를 볼 수 있다는 것을 의미합니다. 마지막으로, 원하는 사용자들의 Sharelook 계정 이메일 주소를 사용하여 당신 기관 내 그리고 기관 외 특정 사용자들에게 공개할 수도 있습니다.',
    SpecificUsersDescription:
      '유료 독립 사용자들: (개인, 공공, 특정 사용자들) 당신의 [코스|이벤트|평가]가 저장되었고 비밀로 초기화됩니다. 이는 당신만이 이 컨텐츠를 볼 수 있다는 것을 의미합니다. 이 컨텐츠 공개를 위해서는 아래에서 선택이 가능합니다. 이 코스를 이는 코스가 이 플랫폼의 모든 사용자들에게 공개된다는 의미입니다. 특정 사용자 옵션을 사용하면 당신의 코스를 Sharelook 계정에 연결된 이메일 주소들을 사용하여 특정 사용자들과 공유할 수 있습니다. '
  },
  quiz: {
    quiz_empty: '아직 퀴즈를 생성하지 않았습니다',
    questions_empty: '아직 퀴즈를 생성하지 않았습니다'
  },
  regions: {
    asia_pacific_australia: '호주',
    asia_pacific_india: '인도',
    asia_pacific_japan: '일본',
    asia_pacific_s_korea: '한국',
    asia_pacific_singapore: '싱가폴',
    asia_pacific_taiwan: '대만',
    eu_belgium: '벨기에',
    eu_germany: '독일',
    eu_ireland: '아일랜드',
    south_america_brazil: '브라질',
    us_central_iowa: '아이오와',
    us_east_s_carolina: '사우스 캐롤라이나',
    us_east_virginia: '버지니아',
    us_west_california: '캘리포니아',
    us_west_oregon: '오레곤'
  },
  reports: {
    title: '리포드들',
    workshop_report: '워크샵 보고서',
    user_report: '사용자 보고서',
    organization_workshop: '기관 워크샵',
    course: '코스',
    live_event: '라이브 이벤트',
    workShop_graph: '워크샵 그래프',
    organization_accaaount: '기관 계정',
    all: '모두',
    name: '이름',
    id_number: '아이디 번호',
    email: '이메일',
    search_user_report: '사용자 보고서 검색',
    participant: '참가자',
    participants: '참가자들',
    host: '호스트',
    username: '아이디',
    event: '이벤트',
    quiz: '퀴즈',
    assessment: '평가',
    time: '시간',
    no_recent_activity: '최근 활동내역 없음',
    workshops: '워크샵',
    courses: '코스들',
    live_events: '라이브 이벤트',
    live_assessments: '라이브 평가',
    quizzes: '퀴즈들',
    overview: '전체보기',
    by: '에 의해',
    views: '시청수',
    status: '상태',
    poll: '설문',
    comment: '댓글',
    comments: '댓글들',
    no_comments: '댓글 없음',
    no_polls: '설문 없음',
    live_date: '라이브 날짜',
    score: '점수',
    question: '질문',
    submit: '접수',
    recent_activity: '최근 활동',
    ago: '전',
    no_data_found: '정보 없음',
    start_end_live: '라이브 시작 / 종료',
    join_leave_date: '참가 / 나가기',
    watched_time: '시청 시간',
    complete: '완료',
    in_complete: '완료',
    today: '오늘',
    seven_days: '7 일',
    last_month: '지난 달',
    one_year: '1년',
    all_time: '전체',
    report: '보고',
    from_date: '시작 날짜',
    to_date: '끝 날짜',
    all_workshop: '모든 워크샵',
    all_participants: '모든 참가자들',
    live_assessment: '라이브 평가',
    users: '사용자들',
    download: '다운로드',
    recent: '최근',
    WorkShop: '워크샵',
    Activity: '활동',
    created_date: '생성 날짜',
    lessons: '레슨들',
    lesson: '레슨',
    completed: '완료됨',
    report_download: '보고 다운로드',
    this_month: '이 달',
    search_course: '코스 검색 ',
    participants_graph: '참가자 그래프',
    viewed: '시청',
    enrolled: '등록됨',
    description: '설명',
    topic: '주제',
    analytic: '분석',
    quiz_list: '퀴즈 목록',
    select_one: '한 개 선택',
    group_status: '그룹 상태',
    duration_min: '길이 (분)',
    submit_poll: '설문 접수',
    download_events: '이벤트 다운로드',
    search_event: '이벤트 검색',
    duration: '길이',
    total_participants: '총 참가자들',
    message: '메시지',
    avg_message: '평균 메시지',
    per_message: '메시지/이벤트 퍼센트'
  },
  signup: {
    success_step1:
      '당신이 제공한 이메일 주소로 인증 코드를 보냈습니다, 아래 필드에 붙여넣기하여 당신의 등록을 인증하세요.',
    success_step2: '감사합니다. 성공적으로 등록되었습니다.',
    privacy: 'Sharelook의 <1> 약관</1> 과 <3> 사생활보호정책</3>에 동의합니다'
  },
  stream: {
    emotion_impressive: '훌륭한',
    emotion_unimpressive: '별로',
    message_not_started: '곧 다가옴',
    message_running: '라이브',
    message_processing:
      '저희는 현재 플레이백을 위해 라이브 녹화를 처리 중 입니다. 비디오를 시청하고 평가와 피드백을 계속해서 추가하기 위해 잠시후 다시 확인해주세요.'
  },
  tabs: {
    audience: '관중',
    course: '코스 전체보기',
    details: '라이브 이벤트 상세정보',
    description: '설명',
    host: '호스트',
    lesson: '레슨 전체보기',
    lessons: '레슨',
    overview: '전체보기',
    page: '페이지 빌더',
    publish: '출판',
    settings: '출판 설정',
    total_views: '총 시청수',
    live_participates: '라이브 참가자들',
    live_chats: '라이브 채팅',
    live_quiz: '라이브 투표',
    trainer_rating: '훈련가 평가',
    trainer_times: '훈련가 시간',
    courses_quizzes: '코스 퀴즈들',
    user_list: '사용자 목록',
    discussion: '토론',
    notes: '내 노트들'
  },
  topics: {
    SALES_TRAINING: '세일즈 훈련',
    NEGOTIATION_TRAINING: '협상 훈련',
    CROSS_CULTURAL_AWARENESS: '다문화 지식',
    NETWORKING_SKILLS: '네트워킹 기술',
    SOFTWARE_ARCHITECTURE: '소프트웨어 아키텍쳐',
    PROJECT_MANAGEMENT: '프로젝트 매니지먼트',
    DIGITAL_TRANSFORMATION: '디지털 트랜스포메이션',
    IT_CONSULTING: 'IT 컨설팅',
    MANAGEMENT_CONSULTING: '매니지먼트 컨설팅',
    HR_CONSULTING: 'HR 컨설팅',
    INTERNET_OF_THINGS: 'Internet of Things (IoT)',
    CYBERSECURITY: '사이버 시큐리티',
    PRIVACY_AND_GDRP: '사생활보호 및 GDPR'
  },
  training: {
    title: '훈련',
    title_assessment: '평가',
    subtitle: '코스 및 라이브 이벤트',
    enrolled_title: '등록된 코스들 및 라이브 이벤트',
    enrolled_subtitle: '당신이 등록한 코스 및 라이브 이벤트들',
    enrolled_message:
      '당신은 현재 아무 코스 또는 라이브 이벤트에 등록되어 있지 않습니다',
    past_live_event_title: '과거 라이브 이벤트',
    past_live_event_subTitle: '끝난 라이브 이벤트',
    past_live_event: '과거 라이브 이벤트가 없습니다',
    recomended_title: '추천된 코스 및 라이브 이벤트들',
    now_live_event_title: '현재 라이브',
    now_live_event_subTitle: '현재 라이브 또는 곧 라이브 될 이벤트들',
    now_live_event: '현재 라이브 이벤트가 없습니다',
    webinar_event_title: '웨비나 채널',
    webinar_event_subTitle: '끝난 웨비나',
    webinar_event: '현재 웨비나가 없습니다',
    p2p_event_title: '코칭 세션',
    p2p_event_subTitle: '끝난 코칭 세션들',
    p2p_event: '현재 코칭 세션이 없습니다',
    now_live_assessment_title: '현재 라이브',
    now_live_assessment_subTitle: '현재 라이브 또는 곧 라이브 될 평가',
    now_live_assessment_message: '현재 라이브 평가가 없습니다',
    upcoming_assessment_title: '다가오는 라이브 평가',
    upcoming_assessment_subtitle: '다가오는 라이브 평가들',
    upcoming_assessment_message: '현재 다가오는 라이브 평가가 없습니다',
    past_live_assessment_title: '과거 라이브 평가',
    past_live_assessment_subTitle: '끝난 라이브 평가들',
    past_live_assessment_message: '현재 과거 라이브 평가들이 없습니다',
    recomended_subtitle:
      '당신의 <0><0/></0> 을 근거로 하여 코스와 라이브 이벤트들을 선별하였습니다',
    search: '훈련 검색',
    search_assessment: '평가 검색',
    recomended_message: '현재 추천된 코스나 평가들이 없습니다'
  },
  warnings: {
    delete: '확실한가요?'
  },
  workshop: {
    title: '내 워크샵',
    subtitle: '당신만의 코스를 만들거나 라이브 이벤트를 주췌하세요',
    new_course: '새 코스 만들기',
    new_event: '새 라이브 이벤트 만들기',
    new_assessment: '새 라이브 평가 만들기',
    courses_title: '코스 & 라이브 이벤트를 만들었습니다',
    courses_subtitle:
      '만든 코스를 편집 & 출판하고 라이브 이벤트들을 계획하세요',
    tags_course: '코스',
    tags_live: '라이브 이벤트',
    tags_assessment: '라이브 평가'
  },
  help_center: {
    sidebar: {
      title: '어떻게 도와드릴까요?',
      back_to: '대쉬보드'
    },
    menu: {
      help_center: '도움 센터',
      whats_new: '새소식',
      feedback: '피드백',
      feedback_title: 'Sharelook에 피드백 보내기',
      terms_and_conditions: '약관',
      privacy_policy: '사생활보호 정책',
      contact_us: '연락처'
    },
    get_started: {
      title: 'Sharelook 시작하기',
      description: {
        main: '사용이 쉬운 코스 빌더에 라이브 비디오를 결합하였습니다',
        tagline:
          'ShareLooks의 특허 라이브 방송 시스템으로 참가를 이끌어내고, 학습을 자동화하고, 지식 공유를 최대화 할 수 있습니다'
      }
    }
  },
  whats_new: {
    title: 'ShareLook으로 시작하세요',
    description: {
      main:
        '스토리 텔링 스타일의 학습을 빠른 시간 내에 저렴하게 만들 수 있다는 것을 아셨나요? ShareLook 코스 빌더와 해당 재능을 조합해야 합니다. 저희에게 그 방법을 물어보실 수 있습니다',
      tagline: '태그라인'
    }
  },
  create_workshop: '워크샵 생성하는 법',
  create_course: '코스 생성하는 법',
  create_user: '사용자 생성하는 법',
  create_group: '그룹 생성하는 법',
  create_webinar: '웨비나 생성하는 법',
  create_live_event: '라이브 이벤트 생성하는 법',
  create_live_assessment: '라이브 평가 생성하는 법',
  create_live_on_mobile: '모바일에서 라이브 생성',
  personalize_profile: '프로파일 개인화',
  manage_group: '그룹 관리',
  report: '보고',
  add_annotations: '주석/팝업 추가 방법',
  add_audio: '오디오 추가 방법',
  add_header_and_footer: '머릿글 & 바닥글 추가 방법',
  add_image: '이미지 추가 방법',
  add_quiz_content: '퀴즈 컨텐츠 추가 방법',
  add_text_content: '텍스트 컨텐츠 추가 방법',
  add_user: '사용자 추가 방법',
  add_video: '비디오 추가 방법',
  clone_course: '코스 복사 방법',
  find_live_broadcast: '라이브 방송 검색 방법',
  contact_us: {
    title: '연락처',
    subject_placeholder: '주제를 입력하세요*',
    content_placeholder: '메시지를 입력하세요*',
    subject_required: '*주제가 필요합니다',
    content_required: '*메시지가 필요합니다',
    submit: '보내기',
    cancel: '취소',
    sent: '보내짐'
  },
  feedback: {
    title: 'sharelook에 피드백 보내기',
    attach_title: '파일 첨부하기',
    choose: '파일 선택하기',
    detail: '파일이 지원 팀과 공유될 것입니다',
    content_placeholder: '메시지를 입력하세요*',
    content_required: '*메시지가 필요합니다',
    submit: '보내기',
    cancel: '취소',
    sent: '보내짐'
  },
  discussion: {
    join_discussion: '토론 참가'
  },
  notes: {
    title: '내 노트들',
    add_note: '새 노트 추가하기'
  }
}
